/**
 * `payroll` translations, for every locale.
 */
export const payroll = {
  mn: {
      payroll: {
        rates: {
          socialLoadFailed: 'НДШ-ийн кодуудыг ачаалж чадсангүй.',
          companyLoadFailed: 'Нөхөх төлбөрийн хувилбаруудыг ачаалж чадсангүй.',
          versionSaveFailed: '{{date}}-ны хувилбарыг хадгалж чадсангүй.',
          tab: 'Цалингийн тариф',
          title: 'Компанийн цалингийн тариф',
          subtitle:
            'Бүх ажилтны цалин тооцоход хэрэглэгддэг нэгдсэн тариф — НДШ-ийн хувь, өдрийн нөхөх төлбөр, НДШ-ийн дээд хязгаар.',
          effectTitle: 'Тариф өөрчлөхөд юу болох вэ',
          effectIssued: 'Баталгаажсан цалин ХӨДӨЛӨХГҮЙ — олгосон дүнгээрээ хадгалагдана.',
          effectDrafts:
            'Харин баталгаажаагүй (Draft) тооцоо БҮГД шинэ тарифаар дахин бодогдоно.',
          socialTitle: 'Нийгмийн даатгалын хувь',
          socialSubtitle:
            'Код тус бүрийн өнөөдөр мөрдөгдөж буй ажилтны хураамж ба хувь хүний орлогын албан татвар. Мөр бүр мөрдөгдөж эхэлсэн өдрөөсөө хэрэгжинэ; түүнээс өмнөх сарууд хуучин хувиараа үлдэнэ.',
          socialStatutory:
            'Эдгээр хувь хуулиар тогтоогдсон бөгөөд бүх байгууллагад нэг адил. Энд засах боломжгүй — системийн шинэчлэлээр өөрчлөгдөнө.',
          socialEmpty: 'Нийгмийн даатгалын код бүртгэгдээгүй.',
          colCode: 'Код',
          colContribution: 'Ажилтны хураамж',
          colTax: 'ХХОАТ',
          colDescription: 'Тайлбар',
          bandExists: '«{{code}}» код аль хэдийн бүртгэлтэй — хүснэгтээс засна уу.',
          companyTitle: 'Нөхөх төлбөр ба НДШ-ийн дээд хязгаар',
          companySubtitle:
            'Хүчин төгөлдөр болох өдрөөр хувилбарладаг. Тооцоо тухайн сард хүчинтэй байсан хамгийн сүүлийн мөрийг уншина.',
          companyEmpty: 'Тариф бүртгэгдээгүй — нөхөх төлбөр 0, НДШ хязгааргүй бодогдоно.',
          colEffectiveSince: 'Мөрдөх огноо',
          colField: 'Хөдөө (F)',
          colBta: 'Гадаад томилолт (BTA)',
          colBtl: 'Дотоод томилолт (BTL)',
          colTransit: 'Замын (T)',
          colCap: 'НДШ-ийн дээд хязгаар',
          newVersionTitle: 'Шинэ хувилбар нэмэх',
          newVersionHint:
            'Шинэ өдөр нэмэх нь өмнөх сарууудад нөлөөлөхгүй. Одоо байгаа өдрийг сонговол тэр хувилбар дарж бичигдэнэ.',
          versionExists: '{{date}}-нд хувилбар аль хэдийн байна — хадгалбал дарж бичигдэнэ.',
          confirmVersion:
            '{{date}}-ны хувилбарыг дарж бичих үү? Тэр өдрөөс хойшхи баталгаажаагүй тооцоо дахин бодогдоно.',
          addVersion: 'Хувилбар нэмэх',
          replaceVersion: 'Хувилбарыг дарж бичих',
          saved: 'Тариф хадгалагдлаа.',
          invalidBlank: 'хоосон байна',
          invalidNotANumber: 'тоо байх ёстой',
          invalidNegative: 'сөрөг байж болохгүй',
          invalidAboveMaximum: '100%-аас их байж болохгүй',
          invalidTooPrecise: 'аравтын 2 орноос хэтэрсэн',
        },
        issue: 'Баталгаажуулах', alreadyIssued: 'Баталгаажсан', status_Issued: 'Баталгаажсан', status_Draft: 'Ноорог',
        // Цалингийн сарыг хаах, дахин нээх.
        close: {
          action: 'Цалингийн сарыг хаах',
          hint: 'Хаавал {{start}} – {{end}} хоорондох татгалзсан цагийн хуудас түгжигдэнэ.',
          confirm: '{{year}} оны {{month}}-р сарын цалинг хаах уу? Ажилтнууд энэ сарын татгалзсан цагийн хуудсаа засах боломжгүй болно. Зөвхөн админ дахин нээж чадна.',
          done: '{{year}} оны {{month}}-р сарын цалинг хаалаа',
          closedBy: '{{year}} оны {{month}}-р сарын цалинг ({{start}} – {{end}}) {{name}} {{when}}-нд хаасан. Энэ сарын татгалзсан цагийн хуудас түгжигдсэн.',
          closed: '{{year}} оны {{month}}-р сарын цалинг ({{start}} – {{end}}) {{when}}-нд хаасан. Энэ сарын татгалзсан цагийн хуудас түгжигдсэн.',
          reopen: 'Сарыг дахин нээх',
          reopenConfirm: '{{year}} оны {{month}}-р сарын цалинг дахин нээх үү? Энэ үйлдэл аудитын бүртгэлд тэмдэглэгдэнэ.',
          reopened: '{{year}} оны {{month}}-р сарын цалинг дахин нээлээ',
          notEnded: 'Энэ сар {{end}} хүртэл үргэлжилнэ.',
          lockedWhy: 'Энэ цалингийн сар түгжигдсэн: зөвхөн {{until}} хүртэл өөрчлөх боломжтой байсан.',
          notClosedLocked: '{{year}} оны {{month}}-р сарын цалинг хаагаагүй: энэ сар түгжигдсэн, өөрчлөх хугацаа нь дууссан. Юу ч хадгалагдаагүй.',
        },
        clearOverride: 'Гараар оруулсныг цуцлах',
        noPayCalendar: '{{year}} оны {{month}}-р сарын цалингийн хуваарь оруулаагүй тул огтлолтын огноог дүрмээр тооцов: {{advance}}, {{final}}.',
        noPayCalendarEmpty: 'Цалингийн хуваарь хараахан алга тул {{year}} оны {{month}}-р сарын огтлолтын огноог дүрмээр тооцов: {{advance}}, {{final}}. Хуваарь нь Админ, Тохиргоо, Баярын хуанли хэсэгт энэ оныг баталгаажуулснаар үүснэ.',
        short: { amounts: 'Дүн', periods: 'Хуваарь', info: 'Мэдээлэл', attention: 'Анхаарах', futureLeave: 'Ирэх чөлөө', excel: 'Excel', settlements: 'Тооцоо' },
        showAmounts: 'Дүнг харуулах', hideAmounts: 'Дүнг нуух',
        blockedCount: '{{count}} ажилтны цалинг тооцох боломжгүй тул тооцоололд орохгүй.',
        held: {
          pending: '{{count}} хүлээгдэж буй',
          rejected: '{{count}} татгалзсан',
          title: '{{name}}: цалинд тооцогдоогүй өдрүүд',
          explain: 'Эдгээр өдөр энэ тооцоонд багтах бөгөөд батлагдсан бол тооцогдох байсан.',
          date: 'Огноо',
          hours: 'Цаг',
          status: 'Төлөв',
          statusPending: 'Хүлээгдэж буй',
          statusRejected: 'Татгалзсан',
          open: 'Цагийн хуудсанд нээх',
          closeWarning: 'Энэ цалингийн сард батлагдаагүй эсвэл татгалзсан {{count}} өдөр цалинд тооцогдохгүй. Та хаах боломжтой хэвээр байна.',
        },
        lateLogsTitle: 'Хаалтын огнооноос хойш батлуулахаар илгээсэн бүртгэл',
        lateLogsNone: 'Байхгүй.',
        lateLogThisPeriod: '{{name}} {{day}} ({{hours}} ц) — энэ үед олгоно',
        lateLogNextPeriod: '{{name}} {{day}} ({{hours}} ц) — {{period}}-д шилжинэ',
        monthBlockedNotice: '{{year}}-{{month}}-ийн цалин түгжигдсэн: цалингийн сарыг зөвхөн дараагийн сарын эцэс ({{until}}) хүртэл өөрчилж болно. Одоо засах, баталгаажуулах, буцаах, түгжээ тайлах боломжгүй.',
        issuedRateMissingNotice: 'Гаргасан цалингийн {{count}} мөрөнд тухайн хугацааны компанийн цалингийн тарифын бүртгэл алга. Цалин аль хэдийн гарсан тул өөрчлөгдөхгүй; тарифыг шалгана уу.',
        unpaidFiledNotice: '{{count}} ажилтны бүртгэсэн зарим өдөрт цалингийн тариф хамаарахгүй тул тэр өдрүүдэд цалин бодогдоогүй: {{names}}. Тарифын эхлэх огноог засаад дахин тооцоолно уу.',
        issuedSkipped: '{{count}} ажилтан хасагдсан, засах хүртэл цалин олгогдохгүй: {{names}}',
        selectAll: 'Бүгдийг сонгох',
        selectPerson: '{{name}}-г сонгох',
        finalizeSelected: 'Баталгаажуулах ({{count}})',
        finalizedSelected: '{{count}} ажилтны цалин баталгаажлаа: {{names}}',
        withdrawSelected: 'Буцаан татах ({{count}})',
        withdrawSelectedTitle: '{{count}} хүний цалингийн хуудсыг буцаан татах уу?',
        withdrawSelectedExplain:
          'Сонгосон хүн бүрийн баталгаажсан цалингийн хуудас устгагдахгүй — тоо нь хадгалагдаж, буцаан татсан гэж тэмдэглэгдэнэ, хүн бүрт залруулах ноорог нээгдэж, "Тооцоолж буй" жагсаалтад буцаж орно. Урамшуулал, суутгал, цэвэр залруулга ноорогт шилжих бөгөөд аль хэдийн олгосон гэж юу ч хасагдахгүй.',
        withdrawnSelected: '{{count}} хүний цалингийн хуудсыг буцаан татлаа: {{names}}',
        withdrawSkipped: '{{count}} хүнийг буцаан татаагүй (хүнийг нээж шалтгааныг харна уу): {{names}}',
        calculatingAllIssued: 'Энэ тооцооны бүх хүн баталгаажсан. Тэднийг "Баталгаажсан" хэсгээс харна уу.',
        bankExport: 'Банкны шилжүүлэг',
        bankExportWithheld: '{{count}} ажилтан файлд ороогүй тул цалин шилжихгүй: {{names}}',
        bankNoAccount: 'Банкны данс бүртгэлгүй',
        bankNoPrimary: 'Үндсэн данс сонгоогүй',
        payslipNotSent: 'Цалингийн хуудас илгээгээгүй',
        payslipSent: 'Цалингийн хуудас илгээсэн',
        payslipLanguage: 'Цалингийн хуудасны хэл',
        payslipSentOn: 'Цалингийн хуудас {{date}}-нд илгээсэн',
        excelExportAdvance: 'Урьдчилгаа Excel',
        excelExportFinal: 'Сүүл цалин Excel',
        excelExportEmpty: 'Excel-д гаргах мөр алга.',
        excelExportNoAccount: '{{count}} ажилтны данс бүртгэлгүй тул Excel-д хоосон: {{names}}',
        excelExportNoBank: 'Банк, дансны багана хоосон — данс харах эрх (salary.edit) шаардлагатай.',
        excelExportLeftOut: 'Анхааруулгатай {{count}} мөр Excel-д ороогүй: {{names}}',
        payslipsSent: '{{count}} ажилтанд цалингийн хуудас илгээхээр дараалалд орлоо.',
        payslipsAlreadySent: '{{count}} хуудас аль хэдийн илгээгдсэн — давхар илгээгдэхгүй.',
        payslipsSuppressed:
          'И-мэйл илгээгдсэнгүй: «Товч дарж илгээх и-мэйл» унтраалттай байна. Тохиргоо → Автоматжуулалт хэсгээс асаана уу.',
        payslipsSkipped: '{{count}} ажилтанд илгээгдсэнгүй: {{names}}',
        noneComputed: 'Тооцоологдсон ажилтан алга. «Анхаарах» хэсгийг шалгана уу; юу ч бүртгээгүй хүн жагсаалтад гарахгүй.',
        nothingLoggedCount: 'Юу ч бүртгээгүй: {{count}}',
        reason: 'Шалтгаан',
        issuesTitle: 'Анхаарах',
        issuesHint: 'Одоогоор тооцох боломжгүй. Энд ажилтан байвал баталгаажуулах боломжгүй.',
        issuesNone: 'Асуудал алга.',
        // The third list, and the opt-in that pays annual leave ahead.
        futureLeave: {
          title: 'Ирэх чөлөө',
          blockedFixed: 'Тогтмол цалинтай тул урьдчилан олгохгүй.',
          hint: 'Энэ олголтын хаалтын өдрөөс хойш үргэлжлэх бүх төрлийн чөлөө, ээлжийн амралтыг аль олголт төлөхийг харуулна. Дараагийн олголтын хаалтаас өмнө эхлэх ээлжийн амралтыг энэ олголтод нэмж болно.',
          none: 'Энэ олголтын хаалтаас хойш үргэлжлэх чөлөө алга.',
          person: 'Ажилтан',
          type: 'Төрөл',
          dates: 'Эхлэх – дуусах',
          days: 'Ажлын өдөр',
          pay: 'Цалин',
          cancelPending: 'Цуцлах хүсэлт хүлээгдэж байна',
          paidBy: '{{run}}-д олгосон',
          paidByUnknown: 'Баталгаажсан олголтод олгосон',
          willBePaidBy: '{{run}}-д олгоно',
          eligible: 'Энэ олголтод нэмж болно',
          added: 'Энэ олголтод нэмсэн',
          add: 'Энэ олголтод нэмэх',
          remove: 'Энэ олголтоос хасах',
          addedToast: 'Энэ олголтод нэмлээ.',
          removed: 'Энэ олголтоос хаслаа.',
        },
        typicalShift: {
          loadFailed: 'Төслүүдийг ачаалж чадсангүй.',
          saveFailed: '«{{project}}» төслийн цагийг хадгалж чадсангүй.',
          title: 'Төслийн ердийн ээлжийн цаг',
          subtitle: 'Сул зогсолттой өдөр цалинд тооцох дээд цаг: ажилласан цаг + сул зогсолт энэ тооноос хэтрэхгүй. 2026-09-24-ний өдрөөс хойших ажлын өдрүүдэд хамаарна. Анхдагч утга 11.',
          product: 'Төсөл',
          hours: 'Ердийн цаг',
          save: 'Хадгалах',
          saved: 'Ердийн ээлжийн цаг хадгалагдлаа.',
          invalid: '0-ээс их, 24-өөс ихгүй тоо оруулна уу (2 орон хүртэл бутархай).',
          empty: 'Төсөл алга.',
          inactive: 'идэвхгүй',
        },
        taskRules: {
          loadFailed: 'Даалгаврын тарифын дүрмийг ачаалж чадсангүй.',
          newSetOpen: 'Шинэ дүрмийн маягт нээлттэй байна.',
          createFailed: 'Дүрэм үүсгэж чадсангүй.',
          archiveFailed: '{{name}}-г өөрчилж чадсангүй.',
          deleteFailed: '{{name}}-ийн {{date}}-ны хувилбарыг устгаж чадсангүй.',
          unchanged: 'Өөрчлөх зүйл алга.',
          title: 'Даалгаврын үнийн дүрэм',
          subtitle: 'Даалгавар, нэгжийн шатлалтай цалин. Өдрийн тоо НЭГ шатыг сонгох бөгөөд тэр өдрийн бүх нэгж тухайн шатны тарифаар бодогдоно. Тоо өдөр бүр шинэчлэгдэнэ.',
          effectNotice: 'Хувилбарыг засахад баталгаажаагүй (Draft) тооцоо тухайн огнооноос хойш дахин бодогдоно. Баталгаажсан цалин хөдөлдөггүй. Аюулгүй арга нь шинэ мөрдөх огноо нэмэх явдал.',
          loading: 'Дүрмийн жагсаалтыг ачаалж байна…',
          empty: 'Даалгаврын үнийн дүрэм одоогоор алга.',
          newSet: 'Шинэ дүрмийн багц',
          setName: 'Нэр',
          unitLabel: 'Нэгжийн нэр',
          unitLabelHint: 'Цалингийн хуудсанд оруулсанаар нь харагдана, жишээ нь "хайрцаг". Орчуулагдахгүй.',
          createSet: 'Дүрмийн багц үүсгэх',
          assigned: '{{n}} хүнд оноосон',
          archivedBadge: 'Архивлагдсан',
          archive: 'Архивлах',
          unarchive: 'Сэргээх',
          noVersions: 'Шат алга. Доор эхний мөрдөх огноог нэмнэ үү.',
          colEffectiveSince: 'Мөрдөх огноо',
          colFrom: 'Эхлэх',
          colTo: 'Дуусах',
          colRate: 'Нэгжийн тариф',
          openEnded: 'ба түүнээс дээш',
          addDate: 'Шинэ мөрдөх огноо нэмэх',
          addDateHint: 'Шинэ огноо нэмэх нь өмнөх өдрүүдэд нөлөөлөхгүй. Эхний шат 1-ээс эхэлнэ; "дуусах" нь дараагийн "эхлэх"-ээс автоматаар гарна.',
          editVersion: 'Энэ огноог засах',
          addTier: 'Шат нэмэх',
          removeTier: 'Шат хасах',
          saveNew: 'Мөрдөх огноо нэмэх',
          saveReplace: 'Энэ хувилбарыг дарж бичих',
          cancel: 'Болих',
          versionExists: '{{date}}-нд хувилбар аль хэдийн байна — хадгалбал дарж бичигдэж, баталгаажаагүй тооцоо дахин бодогдоно.',
          confirmOverwrite: '{{date}}-ны хувилбарыг дарж бичих үү? Тэр өдрөөс хойшхи баталгаажаагүй тооцоо дахин бодогдоно.',
          deleteVersion: 'Энэ огноог устгах',
          confirmDelete: '{{date}}-ны хувилбарыг устгах уу? Тэр өдрөөс хойшхи баталгаажаагүй тооцоо дахин бодогдоно.',
          saved: 'Дүрмийн багц хадгалагдлаа.',
          effectiveRequired: 'Мөрдөх огноогоо сонгоно уу.',
          nameRequired: 'Нэр оруулна уу.',
          previewTitle: 'Өдрийг урьдчилан бодох',
          previewCount: 'Өдрийн нэгжийн тоо',
          previewResult: '{{n}} × {{rate}} = {{pay}} ({{min}}-ээс эхэлсэн шат)',
          previewNone: 'Нэгжгүй өдөр цалин олгохгүй.',
          decreasingHint: '{{row}}-р шат өмнөх шатаас нэгжийн тариф бага байна. Зөвшөөрөгдөнө, гэхдээ зориуд хийснээ шалгана уу.',
          invalid_empty: 'Дор хаяж нэг шат нэмнэ үү.',
          invalid_blank: '{{row}}-р шат: тоо болон тарифыг хоёуланг нь бөглөнө үү.',
          invalid_not_a_number: '{{row}}-р шат: тоо оруулна уу.',
          invalid_not_whole: '{{row}}-р шат: тоо бүхэл байх ёстой.',
          invalid_negative_rate: '{{row}}-р шат: тариф сөрөг байж болохгүй.',
          invalid_too_precise: '{{row}}-р шат: тариф хамгийн ихдээ 2 аравтын оронтой байна.',
          invalid_first_not_one: 'Эхний шат 1-ээс эхлэх ёстой.',
          invalid_not_increasing: '{{row}}-р шат: тоо дээрх шатнаас их байх ёстой.',
          segPay: 'Даалгаврын цалин',
          segUnitDefault: 'даалгавар',
        },
        warn: {
          rate_missing: 'Цалингийн тариф оруулаагүй',
          payroll_rate_missing: 'Энэ хугацаанд компанийн цалингийн тарифын бүртгэл алга',
          shift_source_missing: 'Ээлжийн мэдээлэл алга (ээлжийн хуваарь сервертэй холбогдоогүй)',
          social_band_missing: 'НД-ийн ангилал олдсонгүй',
          leave_factor_missing: 'Өмнөх 12 сарын цалингийн түүх алга тул амралтын дундаж тооцоогүй',
          pay_basis_unrecognised: 'Цалингийн тооцооны төрөл танигдсангүй',
          task_rule_version_missing: 'Даалгаврын үнийн дүрэмд ажилласан өдөр хүчинтэй хувилбар алга тул тэр өдрийг 0-ээр бодсон',
          unpaid_filed_days: 'Бүртгэсэн {{count}} өдөрт цалингийн тариф хамаарахгүй тул цалин бодогдоогүй: {{days}}',
          cl_year_end_unpriced: 'Цалингийн тариф алга тул жилийн эцсийн чөлөөний үлдэгдлийн олговрыг тооцоогүй',
          psl_year_end_reset_missing: 'Өнгөрсөн оны 12-р сарын 31-ний чөлөөний тэглэлт хийгдээгүй тул ашиглаагүй PSL-ийн олговрыг энэ сүүл цалинд тооцоогүй',
          contractor_entry_unpriced: 'Гэрээтийн батлагдсан бүртгэлийн өдөрт Өдөр+Цаг тариф хамаарахгүй тул тооцоогүй',
          final_issued: 'Энэ сарын эцсийн цалин урьдчилгаанаас өмнө олгогдсон тул урьдчилгааг олгохгүй',
          break_payout_balance_short: 'ЭА, CL эсвэл PSL-ийн үлдэгдэл амралтын олговор үүсэх үед тооцсон хэмжээнээс бага болсон тул олгохгүй: олговрыг хүчингүй болгоод гараар тооцно уу',
          break_payout_leave_row_changed: 'Амралтын олговор үүссэнээс хойш чөлөөний үлдэгдэл шинээр олгогдсон тул олгохгүй: олговрыг хүчингүй болгоод гараар тооцно уу',
        },
        period: 'Тооцооны хугацаа', people: 'Ажилтан', totalGross: 'Нийт цалин', gross: 'Нийт цалин',
        company: 'Компани', model: 'Хэлбэр', modelDaily: 'Өдрөөр', modelFixed: 'Тогтмол', modelHourly: 'Цагаар',
        rate: 'Тариф', worked: 'Ажилласан (цаг/ээлж)',
        run: 'Тооцоо', run_advance: 'Урьдчилгаа', run_final: 'Эцсийн',
        mode: 'Горим', mode_calculating: 'Тооцоолж буй', mode_issued: 'Баталгаажсан',
        selectAllIssued: 'Баталгаажсан бүгдийг сонгох',
        noneIssued: 'Энэ тооцоонд баталгаажсан хүн алга.',
        sendPayslip: 'Цалингийн хуудас илгээх ({{count}})',
        sendPayslipTitle: '{{count}} хүнд цалингийн хуудас илгээх үү?',
        sendPayslipExplain: 'Энэ цалингийн хуудсыг аль хэдийн хүлээн авсан хүнд дахин илгээхгүй. Цуцалж засаад дахин гаргасан хуудсыг дахин илгээнэ. Илгээсний дараа буцаах боломжгүй.',
        covers: '{{start}} → {{end}} хугацааг хамарна',
        heading: {
          progress: '{{month}}, {{run}} — {{issued}} баталгаажсан, {{left}} үлдсэн',
          notIssued: '{{month}}, {{run}} — хараахан баталгаажаагүй, тасалбар өдөр {{cutOff}}',
          notIssuedNoCut: '{{month}}, {{run}} — хараахан баталгаажаагүй',
        },
        social: 'НДШ', tax: 'ХХОАТ', net: 'Цэвэр цалин',
        advance: 'Урьдчилгаа', remainder: 'Үлдэгдэл олговор',
        totalAdvance: 'Нийт урьдчилгаа', totalRemainder: 'Нийт үлдэгдэл', totalNotKnown: 'Тодорхойгүй',
        advancePaid: 'Олгосон урьдчилгаа',
        // Эцсийн тооцоонд үлдэгдэл яг 0 гардаг цорын ганц шалтгаан: урьдчилгаагаар
        // цэвэр цалинг бүрэн олгосон. "0" гэж харуулбал юу ч аваагүй мэт харагдана.
        settledByAdvance: 'Урьдчилгаагаар бүрэн олгосон (Нийт цалин {{gross}})',
        advanceAdjustment: 'Урьдчилгаанаас шилжсэн тохируулга',
        netAdjustment: 'Татварын дараах тохируулга',
        clYearEndPay: 'Ашиглаагүй PSL-ийн олговор',
        payNote: {
          pslPriced: 'PSL {{days}} хоног x 8 цаг x {{rate}} = {{amount}}',
          pslLapseFixed: 'PSL {{days}} хоног ({{year}}) тогтмол цалинтай тул төлбөргүй дуусна',
          breakNetZero: 'CL олговор {{award}} хоногоос буцаасан {{back}} хоногийг хасахад 0 хоног',
          breakUnpaidFixed: 'CL/PSL {{days}} хоног тогтмол цалинтай тул төлбөргүй тооцогдоно',
          breakUnpaid: 'CL/PSL {{days}} хоног төлбөргүй тооцогдоно',
        },
        activityBonus: 'Үйл ажиллагааны сангийн урамшуулал',
        loadFailed: 'Энэ цалингийн бодолтыг ачаалж чадсангүй.',
        activityWorking: '{{months}} сар төлсөн · {{points}} оноо × {{rate}} = {{total}}',
        activityNoMonths: 'Тэр жил санд төлсөн сар алга',
        activityFund: {
          mark: 'Энэ цалингаар олгох',
          unmark: 'Тэмдэглэгээг арилгах',
          unmarked: '{{fundYear}} оны үйл ажиллагааны сангийн урамшууллыг энэ эцсийн цалингаар олгоогүй',
          marked: 'Энэ эцсийн цалин {{fundYear}} оны үйл ажиллагааны сангийн урамшууллыг олгоно: оноо × сарын хандив',
          elsewhere: '{{fundYear}} оны үйл ажиллагааны сангийн урамшууллыг {{year}}-{{month}} сарын эцсийн цалингаар олгоно',
          off: 'Татварын асуудал шийдэгдэх хүртэл энэ байгууллагад үйл ажиллагааны сангийн урамшуулал унтраалттай байна',
          hint: 'Жилд нэг эцсийн цалинг тэмдэглэнэ. Энэ цалин {{fundYear}} онд санд төлсөн сар бүрийн оноог сарын хандиваар үржүүлж олгоно; дүнг гараар өөрчлөхгүй, засварыг сангийн хүснэгтэд хийнэ.',
          markConfirm: '{{fundYear}} оны үйл ажиллагааны сангийн урамшууллыг энэ эцсийн цалингаар олгох уу?',
          unmarkConfirm: 'Энэ эцсийн цалингаас {{fundYear}} оны үйл ажиллагааны сангийн урамшууллыг хасах уу?',
          markDone: '{{fundYear}} оны урамшууллыг энэ цалинд нэмлээ',
          unmarkDone: '{{fundYear}} оны урамшууллыг энэ цалингаас хаслаа',
          blocked: {
            future: 'Ирээдүйн оны цалинг тэмдэглэх боломжгүй',
            issued: 'Энэ цалингийн цалингийн хуудас гарсан; эхлээд хүчингүй болгоно уу',
            locked: 'Энэ сар хаагдсан эсвэл түгжигдсэн',
          },
        },
        breakAlPay: 'Чөлөө эхлэх эсвэл бүтэн цагаас шилжихэд: олгосон ээлжийн амралт (татварын дараа)',
        breakClPslPay: 'Үүнээс чөлөө эхлэх эсвэл бүтэн цагаас шилжихэд CL/PSL тооцоо (цалин шиг татвартай)',
        leavePayoutOfWhich: 'Үүнээс ажлаас гарахад ашиглаагүй чөлөөний нөхөн олговор',
        alSettlementOfWhich: 'Үүнээс таны хүсэлтээр мөнгөөр олгосон жилийн амралт',
        // Ажилтны өөрийн цалингийн хуудасны портал
        paidOut: 'Олгосон дүн',
        viewPayslip: 'Дэлгэрэнгүй',
        shiftsN: '{{count}} ээлж', hoursN: '{{count}} цаг',
        shiftsUnit: 'ээлж', tasksUnit: 'даалгавар', hoursUnit: 'цаг',
        socialTag: 'НД ангилал {{tag}}',
        socialAt: 'НДШ {{percent}}%', taxAt: 'ХХОАТ {{percent}}%',
        socialCapped: 'Дээд хязгаар: {{cap}}-аас дээш цалингаас НДШ нэмж тооцогдохгүй.',
        segmentTotal: 'Тарифын хугацаанууд', segmentGross: 'Тухайн хугацааны цалин', allowances: 'Нэмэгдэл',
        p73: {
          help: "Тайлбар",
          reportedHours: "Бүртгэсэн цаг",
          weightedHours: "Жигнэсэн цаг",
          reportedShifts: "Бүртгэсэн ээлж",
          weightedShifts: "Цалинд тооцсон ээлж",
          hoursTitle: "Цаг: бүртгэсэн (жигнэсэн)",
          paidLeave: "Төлөгдсөн чөлөө (PSL / CL / SPL)",
          annualLeave: 'Ээлжийн амралт (AL)',
          annualLeaveDays: "{{days}} өдөр · {{hours}} цаг",
          shiftsTitle: "Ээлж: бүртгэсэн (цалинд тооцсон)",
          taskTotal: "{{count}} даалгавар = {{amount}}",
          taskDatesUnavailable: "Энэ тооцоонд өдөр бүрийн даалгаврын задаргаа хадгалагдаагүй. Нийт дүн зөв, өдрөөр нь харуулах боломжгүй.",
          t60: "Замын цаг, 60%-иар тооцогдоно",
          totals: "Нийт",
          normalHint: "H, DT, PD нь нэг дүнгээр тооцогдоно: H {{h}} · DT {{dt}} · PD {{pd}}",
          gap: "Дээрх өдрүүд цалингийн нийт цагаас {{sign}}{{gap}} цагаар зөрж байна — шилжсэн өдөр үүнийг үүсгэж болно.",
          hoursHelp: "Нүд бүр: бүртгэсэн цаг (жигнэсэн цаг). Коэффициент: илүү цаг 1.5, шөнө 1.2, шөнө + ИЦ 1.8, зам 0.6. PD нь өдрийн ажлын 10%-иар хязгаарлагдана; сул зогсолт 60%-иар тооцогдох ба 2026-09-24-өөс төслийн ердийн ээлжийн цагаар хязгаарлагдана. H, DT, PD нь нэг дүнгээр бөөрөнхийлөгдөнө. Нийт мөр нь цалингийн өөрийн дүн; цалинтай чөлөө, баярын өдөр тус бүр 8 цаг. Тогтмол цалинтай өдрийн цалин цагаас хамаарахгүй.",
          shiftsHelp: "Огноо бүр: бүртгэсэн ээлж (цалинд тооцсон ээлж). Замын (T) ээлж 60%-иар тооцогдоно. Нийт нь цалингийн өөрийн ээлжийн тоо. Цалинд тооцсон ээлжийг төрлөөр нь задалсан: D өдөр, N шөнө, L мод бэлтгэл, T зам (×0.6), DT зогсолт (×0.6).",
          formulaHelp: "Мөр бүр: тоо × коэффициент × үнэлгээ. Коэффициент нь үнэлгээг яг хуваах үед л харагдана. Нийлбэр нь нийт цалинтай тэнцэх ёстой. Хоёр дахь (нэмэлт) үнэлгээтэй Daily хэсэг нэг мөрөөр, тоо × үнэлгээгүй харагдана: аль ээлжинд аль үнэлгээ ногдсоныг хадгалсан хэлбэр нь агуулдаггүй.",
          figuresHelp: "НДШ = min(нийт цалин, дээд хязгаар) × хувь; хязгаар ба хувь нь тухайн сарын эцсийн тооцооны өдөр (final cut) мөрдөгдөж буй НДШ-ийн кодоос ирнэ. ХХОАТ = (нийт цалин − НДШ) × татварын хувь. Чөлөөлөлт нь тухайн сард тэр хувийг 0 болгоно.",
          socialBaseCapped: "Суурь: min(нийт {{gross}}, хязгаар {{cap}}) = {{base}}",
          socialBaseGross: "Суурь: нийт цалин {{base}} (хязгаар тохируулаагүй)",
          baseNotRecorded: "Суурь: баталгаажсан цалинд бүртгэгдээгүй",
          taxBase: "ХХОАТ-ын суурь (нийт цалин − НДШ)",
          figuresTitle: "Эцсийн дүн",
          exemptSocial: "НДШ-ээс чөлөөлөгдсөн (0%)",
          exemptTax: "ХХОАТ-аас чөлөөлөгдсөн (0%)",
          ratePeriods: "Үнэлгээний хугацаа ({{count}})",
        },
        dayHours: {
          day: 'Өдөр', ordinary: 'Үндсэн цаг', downtime: 'Сул зогсолт', pd: 'PD',
          total: 'Өдрийн нийт',
          carried: 'өмнөх сар', fixed: 'тогтмол цалин',
          notRecorded: 'Энэ мөрийг баталгаажуулах үед өдөр тутмын цаг хадгалагдаагүй.',
          
        },
        frozenAtIssue: 'Баталгаажуулах үед хөлдөөсөн задаргаа. Цагийн бүртгэл хожим засагдсан ч энэ өөрчлөгдөхгүй.',
        carryOver: 'Өмнөх сарын өдөр — тухайн үеийн цалин баталгаажсаны дараа зөвшөөрөгдсөн тул тэр өдрийн тарифаар одоо тооцов.',
        noFrozenBreakdown: 'Энэ баталгаажсан мөр задаргаагүй хадгалагдсан тул доорх дүнгүүдийг тайлбарлах бичлэг алга.',
        ledgerSegment: 'Авансын өдрүүд',
        ledgerSegmentWhy: 'Аванс нь өөрөө тариф болон цалин бодох хэлбэргүй — зөвхөн төлсөн өдрүүдийн бүртгэл. Тариф нь төгсгөлийн тооцоонд байна.',
        monthFigureHint: 'Нийт цалин, НДШ болон ХХОАТ бол тухайн сарын бүтэн дүн; Аванс болон Төгсгөл бол тус тусдаа гарт авсан цэвэр дүн.',
        correctionsTitle: 'Залруулгын түүх',
        correctionsNone: 'Энэ сард буцаан татсан цалингийн хуудас алга.',
        withdraw: 'Буцаан татаж, дахин нээх',
        withdrawConfirm: 'Буцаан татах',
        withdrawReason: 'Буцаан татах шалтгаан',
        withdrawExplain:
          'Баталгаажсан хуудас устахгүй — дүнгээ хадгалан «Буцаан татсан» болж, хажууд нь залруулах ноорог нээгдэнэ. Урамшуулал, суутгал, цэвэр дүнгийн залруулга ноорогт шилжих бөгөөд аль хэдийн олгосон гэж юу ч хасагдахгүй.',
        withdrawn: 'Цалингийн хуудсыг буцаан татаж, залруулах ноорог нээлээ.',
        withdrawnLabel: 'Буцаан татсан',
        withdrawnBecause: 'Шалтгаан: {{reason}}',
        p83: {
          workedHint: "Ажилласан цаг (эсвэл ээлж) + энэ цалингаар олгох чөлөө. * = урьдчилан олгосон ээлжийн амралт",
          partHours: "Ажилласан цаг: {{value}}",
          partShifts: "Ажилласан ээлж: {{value}}",
          partTasks: "Гүйцэтгэсэн даалгавар: {{value}}",
          partLeave: "{{code}}: {{value}} цаг, цагт тооцогдсон цалинтай чөлөө",
          partAl: "Ээлжийн амралт: энэ цалингаар {{value}} өдөр олгоно",
          aheadHint: "* урьдчилан олгосон — амралт нь энэ хугацааны дараа эхэлнэ",
          annualLeaveAhead: "Ээлжийн амралт, урьдчилан олгосон",
        },
        p70: {
          carryNoRun: "Өмнөх сарын эцсийн цалин энэ хүнд олгогдоогүй тул тэр өдрийг энэ удаа олгож байна.",
          formulaSince: "({{date}}-нээс)",
          carriedLeave: "Хожуу батлагдсан чөлөө: {{leave}} өдөр",
          segmentHolidays: "Баярын өдрүүд: {{dates}}",
          colModeDays: "Өдөр (F/T)",
          modeDaysHint: "Энэ хугацаанд ажилласан өдөр: F хээр, T тээвэр, BTA гадаад томилолт, BTL дотоод томилолт",
          modeChipHint: "{{code}}: {{days}} өдөр",
          transitNotOnRate: "T: цалингийн нөхцөлд байхгүй",
          transitNotOnRateHint: "Тээврийн өдөр байгаа ч энэ хүний цалингийн нөхцөлд тээврийн нэмэгдэл ороогүй.",
          formulaTitle: "Нийт цалин хэрхэн бодогдсон",
          formulaMismatch: "Нэмэгдэхүүнүүдийн нийлбэр нийт цалинтай тэнцэхгүй байна — цалингийн багт мэдэгдэнэ үү.",
          colLeave: "Чөлөө (CL/PSL/SPL/AL)",
          leaveWaiting: "Чөлөө: серверээс хүлээж байна",
          leaveTotalsLead: "Энэ хугацаанд:",
          leaveTotalsItem: "{{code}} {{days}} өдөр ({{people}} хүн)",
          chipHint: "{{code}} {{days}} өдөр — чөлөөг нь нээх",
          chipUnpaidHint: "{{code}} {{days}} өдөр, зарим нь цалингүй — чөлөөг нь нээх",
          taskValue: "Даалгаврын цалин",
          info: {
            badgeHint: "{{count}} хүн чөлөө эсвэл өмнөх хугацааны цагтай",
            button: "Хугацааны мэдээлэл",
            title: "Энэ цалингийн хугацааны мэдээлэл",
            holidays: "Энэ хугацааны баярын өдрүүд",
            noHolidays: "Энэ хугацаанд баярын өдөр алга.",
            notReported: "Мэдээлэгдээгүй",
            carried: "Энэ цалинд орсон өмнөх хугацааны мөнгө",
            noCarried: "Өмнөх хугацаанаас ирсэн мөнгө алга.",
            carriedLeaveNotReported: "Хожуу батлагдсан чөлөө (P67) тус тусдаа мэдээлэгдээгүй — дээрх өдрүүдэд багтсан байж болно.",
            other: "Цалинд нөлөөлөх бусад зүйл",
            draft: "Ноорог",
            issued: "Баталгаажсан",
            issues: "Тооцоолох боломжгүй",
            leaversNotReported: "Ажлаас гарсан / орсон, сайн дурын ажилтны мэдээлэл серверээс хараахан ирээгүй.",
            fact: {
              unlocked: "Түгжээ тайлсан аванс",
              taxExempt: "ХХОАТ-аас чөлөөлөгдсөн",
              socialExempt: "НДШ-ээс чөлөөлөгдсөн",
              grossOverride: "Нийт цалинг гараар зассан",
              figuresUnrecorded: "Дүн бүртгэгдээгүй (импорт)",
            },
            prevTime: "Шилжсэн цаг",
            prevUnpaidFiled: "Тарифгүй бүртгэсэн өдөр, цалин бодогдоогүй: {{dates}}",
            prevNoRun: "{{period}}-ийн эцсийн цалин олгогдоогүй — тэр хугацааг энд олгоно: {{days}} өдөр",
            prevNoRunAl: "Ээлжийн амралт {{days}} өдөр (AL)",
            prevNoRunHours: "{{hours}} цаг",
          },
          leavesTitle: "Энэ цалингийн хугацааны чөлөө",
          leavesCaveat: "Зөвхөн энэ цалингийн жагсаалтад байгаа хүмүүс харагдана — жагсаалтад ороогүй ажлаас гарсан болон сайн дурын ажилтан харагдахгүй.",
          leavesNone: "Энэ цалингийн хугацаанд хэн ч чөлөө аваагүй.",
          leavesUnknown: "Сервер чөлөөний мэдээлэл хараахан илгээгээгүй байна.",
          colName: "Нэр",
          colType: "Чөлөөний төрөл",
          colDates: "Огноо",
          colDays: "Өдөр",
          colPaid: "Хэрхэн олгосон",
          leaveCountHint: "Энэ хугацааны чөлөөний өдөр: CL / PSL / SPL / AL",
          groupFullTime: 'Үндсэн ажилтан',
          groupRest: "Бусад",
          workedPlusLeave: "Ажилласан + чөлөө: {{dates}}",
          personLeavesTitle: "Энэ хугацааны чөлөө",
          personLeavesNone: "Энэ хугацаанд чөлөө аваагүй.",
          personLeavesUnlisted: "Цалинд тооцогдохгүй чөлөө л байна (жишээ нь RL, UL).",
          uncountedLeave: "Чөлөө, 0 өдөр",
          uncountedLeaveHint: "Энэ хугацаанд батлагдсан чөлөө байгаа ч энэ тооцоонд нэг ч өдөр тооцогдоогүй — чөлөөг нь нээх",
          halfDay: "хагас өдөр",
          part: {
            normal: "Үндсэн",
            overtime: "Илүү цаг",
            night: "Шөнийн",
            over_night: "Шөнө + ИЦ",
            transit: "Замын",
            leave: "Цалинтай чөлөө",
            holiday: "Баярын өдөр",
          },
          treatment: {
            paid: "Цалинтай",
            partly_paid: "Хэсэгчлэн цалинтай ({{paid}} / {{days}} өдөр)",
            over_annual_cap: "Жилийн хязгаар хэтэрсэн — цалингүй",
            annual_leave: "Ээлжийн амралт (амралтын олговроор)",
            covered_by_fixed_salary: "Тогтмол цалинд багтсан",
            not_paid: "Цалингүй",
            not_recorded: "Бүртгэгдээгүй",
            al_other_run: "Өөр цалингаар олгосон/олгоно",
          },
        },
        p62: {
          decisionsTitle: 'Шийдвэр',
          unlock: 'Түгжээг тайлах',
          unlockConfirm: 'Түгжээг тайлах',
          unlockReason: 'Яагаад тайлж байгаа вэ',
          unlockExplain: 'Олгогдсон урьдчилгааг буцаан татахын өмнө түгжээг санаатайгаар тайлна. Энэ үйлдэл шалтгаантайгаа бүртгэгдэнэ.',
          unlocked: 'Урьдчилгааны түгжээг тайллаа.',
          lockedNote: 'Энэ урьдчилгаа олгогдсон тул түгжээтэй. Буцаан татахын өмнө шалтгаанаа бичээд түгжээг тайлна уу.',
          unlockedNote: 'Түгжээг тайлсан. Шалтгаан: {{reason}}',
          advanceLocked: 'Энэ урьдчилгаа олгогдсон тул түгжээтэй. Эхлээд шалтгаанаа бичээд түгжээг тайлна уу.',
          finalIssued: '{{month}} сарын эцсийн цалин олгогдож энэ урьдчилгааг суутгасан. Эхлээд эцсийн цалинг хүчингүй болгоно уу.',
          oneOffIssued: '{{month}} сарын нэг удаагийн цалингийн хуудас олгогдож энэ сарын нийгмийн даатгалын дээд хязгаараас ашигласан. Эхлээд нэг удаагийн хуудсыг хүчингүй болгож дахин үүсгээд, энэ цалинг дахин олгосны дараа түүнийг олгоно уу.',
          laterIssued: '{{month}} сарын {{run}} цалин үүнээс хойш олгогдсон. Зөвхөн хамгийн сүүлийн цалинг хүчингүй болгох боломжтой тул эхлээд түүнийг хүчингүй болгоно уу.',
          awaitingReissueAsk: '{{names}}-ийн урьдчилгаа хүчингүй болсон бөгөөд дахин олгогдоогүй тул эцсийн цалинг нь олгох боломжгүй. Бусад хүмүүсийн эцсийн цалинг одоо олгох уу?',
          oneOffFirst: '{{month}} сарын нэг удаагийн цалингийн хуудас олгогдож тухайн сарын нийгмийн даатгалын дээд хязгаараас ашигласан. Эхлээд нэг удаагийн хуудсыг хүчингүй болгож дахин үүсгээд, энэ эцсийн цалингийн дараа дахин олгоно уу.',
          oneOffFirstAsk: '{{names}}-д энэ сард олгогдсон нэг удаагийн цалингийн хуудас байгаа тул түүнийг хүчингүй болгож дахин үүсгэхээс өмнө эцсийн цалинг нь олгох боломжгүй. Бусад хүмүүсийн эцсийн цалинг одоо олгох уу?',
          issueOthers: 'Бусдыг баталгаажуулах',
          advanceAwaitingReissue: '{{month}} сарын урьдчилгаа хүчингүй болсон бөгөөд дахин олгогдоогүй байна. Эцсийн цалинг олгохоос өмнө урьдчилгааг дахин олгоно уу.',
          monthClosed: '{{month}} сарын цалин хаагдсан. Үүнийг өөрчлөхийн тулд админ эхлээд сарыг дахин нээх ёстой.',
          monthNoFinalPeriod: '{{month}} сарын эцсийн цалингийн үе хуанлид байхгүй байна. Сарыг хаахын өмнө үүнийг нэмнэ үү.',
          exemptTitle: 'Татвар ба НДШ-ээс чөлөөлөх',
          exemptHint: 'Тухайн өдрөөс хойш эхлэх сар бүрд үйлчилнэ. Баталгаажсан цалин өөрчлөгдөхгүй. Чөлөөлөлтийг дуусгахын тулд хоёр сонголтыг хоёуланг нь унтраасан шинэ мөр нэмнэ үү.',
          exemptTax: 'ХХОАТ-аас чөлөөлөх',
          exemptSocial: 'НДШ-ээс чөлөөлөх',
          exemptNeither: 'чөлөөлөлтгүй',
          exemptSince: 'Хүчинтэй огноо',
          exemptReason: 'Шалтгаан',
          exemptAdd: 'Чөлөөлөлт нэмэх',
          exemptSave: 'Хадгалах',
          exemptSaved: 'Чөлөөлөлтийг хадгаллаа.',
          exemptDelete: 'Устгах',
          exemptRow: '{{since}}-аас: {{what}} — {{reason}}',
          exemptInForce: 'Энэ сард үйлчилж буй: {{what}}',
          calendarUnconfirmed: '{{years}} оны хуанли баталгаажаагүй байгаа тул энэ сарын цалинг тооцож болохгүй. Эхлээд хуанлийг баталгаажуулна уу.',
          openCalendar: 'Хуанли нээх',
          onePerMonth: '{{field}} энэ сарын {{run}} тооцоонд аль хэдийн бичигдсэн. Сард нэг л удаа оруулна — эхлээд тэндээс нь арилгана уу.',
          field_bonus: 'Урамшуулал',
          field_deduction: 'Татварын өмнөх суутгал',
          field_net_adjustment: 'Татварын дараах суутгал',
        },
        leaveTopUp: 'Ээлжийн амралт: {{days}} хоног × {{factor}}',
        leaveInFixed: 'Нэмэгдээгүй: сарын эцэст тогтмол цалин үйлчилж байгаа тул тэр хоногууд аль хэдийн багтсан.',
        bonus: 'Урамшуулал', deduction: 'Суутгал', note: 'Тэмдэглэл',
        shifts: 'Ээлж', includedDays: 'Тооцсон өдөр', alDays: 'Ээлжийн амралтын өдөр (AL)',
        models: 'Цалингийн загвар',
        overrideValue: 'Гараар оруулсан нийт',
        byHand: 'Гараар тооцсон',
        grossSetByPayroll: 'Нийт цалин (цалингийн албанаас тогтоосон)', notApplied: '{{amount}} — тооцогдоогүй',
        allowancesNotApplied: 'Нийт цалинг цалингийн албанаас тогтоосон тул эдгээр нэмэгдэл тооцогдоогүй.',
        proration: 'Хугацааны / сарын ажлын өдөр', reportedHours: 'Бүртгэсэн цаг',
        weightedHours: 'Жигнэсэн цаг',
        perDaily: 'ээлж тутам', perHourly: 'цаг тутам', perFixed: 'сард',
        branchAdditionalShort: 'Хоёрдогч тариф {{rate}}: бүртгэл, сул зогсолт бүтэн, замд 0.6.',
        branchRateShort: 'Үндсэн тарифаар: бүртгэл бүтэн, сул зогсолт ба замд 0.6.',
        periods: 'Цалингийн үеүүд',
        periodsHint: 'Тооцооллын үндэс болдог цалингийн хуваарь бөгөөд Цаг, Амралт модулийн өөрөө засах болон админы засварын хугацааны хязгаар ч үүн дээр тулгуурладаг. Одоог хүртэл зөвхөн импортоор нэмэгддэг байсан.',
        periodsRunningLow: 'Цалингийн хуваарь {{date}}-нд дуусна. Үүнээс хойш бодит цагийг зөвхөн цагийн админ өөрчилж, баталж чадна. Түүнээс өмнө дараагийн оныг хуанли дээр баталгаажуулж, цалингийн үеүдийг үүсгэнэ үү.',
        periodsEnded: 'Цалингийн хуваарь {{date}}-нд дууссан тул бодит цагийг зөвхөн цагийн админ өөрчилж, баталж чадна. Дараагийн оныг хуанли дээр баталгаажуулж, цалингийн үеүдийг үүсгэнэ үү.',
        periodsGenerate: 'Дараагийн үеүүдийг үүсгэх',
        periodsGenerateHint: 'Олгох огнооны дүрмээр тооцоолно: цалинг 11 болон 26-ны, эсвэл түүнээс өмнөх сүүлчийн ажлын өдөр олгоно; таслах огноо нь түүнээс 2 хоногийн өмнө. Нийтийн баяр болон амралтын өдөр олгох огноог урагшлуулна; таслах огноо түүнийг дагах бөгөөд амралтын өдөр тохиож болно. Эдгээр огноог гараар засах боломжгүй — өөрчлөхийн тулд тухайн жилийн амралтын өдрүүдийг баярын хуанли дээр засна уу.',
        periodsYearNotConfirmed: 'Баярын хуанли {{years}} оны хувьд баталгаажаагүй тул тэдгээр сарын огноог зөвхөн долоо хоногийн амралтаар тооцсон бөгөөд нийтийн амралтын өдрүүдийг алдана. {{years}} оныг баярын хуанли дээр баталгаажуулах, эсвэл цөөн сар сонгоно уу.',
        periodsPropose: 'Санал болгох',
        periodsHowMany: 'Хэдэн сар',
        periodsMonthsN: '{{count}} сар',
        periodsProposedNote: '{{note}}',
        periodsNothingToAdd: 'Нэмэх шинэ сар алга.',
        tickFirst: 'Эхлээд дор хаяж нэг хүн чагтална уу.',
        busyWhy: 'Хадгалж байна…',
        firstPage: 'Эхний хуудсанд байна',
        lastPage: 'Сүүлийн хуудсанд байна',
        nothingToExport: 'Экспортлох мөр алга',
        noPeriodLoaded: 'Үе хараахан ачаалагдаагүй байна',
        rowLocked: 'Энэ мөр олгогдсон эсвэл танд засах эрх алга',
        tickOtherMode: 'Энэ хүн нөгөө харагдацад хамаарна',
        closeUnknown: 'Үеийн төгсгөл хараахан тодорхойгүй байна',
        reasonFirst: 'Эхлээд шалтгаанаа бичнэ үү.',
        dateAndReasonFirst: 'Эхлээд огноо болон шалтгаанаа бичнэ үү.',
        periodsLoadFailed: 'Цалингийн хуваарийг ачаалж чадсангүй.',
        periodsProposeFailed: 'Шинэ саруудын саналыг ачаалж чадсангүй.',
        periodsSaveFailed: 'Цалингийн хуваарьт нэмэгдсэнгүй.',
        periodsGenerateSave: 'Сонгосон {{count}} үеийг хадгалах',
        periodsGenerated: '{{count}} үе цалингийн хуваарьт нэмэгдлээ.',
        periodsEmpty: 'Цалингийн хуваарь хараахан алга. Админ, Тохиргоо, Баярын хуанли хэсэгт энэ оныг баталгаажуулснаар үүснэ.',
        periodsReadOnly: 'Хуваарийг харах боломжтой, харин засах эрхгүй байна.',
        periodsMonth: 'Он, сар',
        periodsPayDate: 'Олгох огноо',
        periodsCutOff: 'Тасалбар',
        daysPaid: 'Ажилласан өдрүүд', shiftDaysPaid: 'Ээлжийн өдрүүд',
        holidaysCredited: 'Тооцсон баярын өдрүүд (өдөрт 8 цаг)',
        excludedDays: 'Тооцоонд ороогүй өдрүүд',
        excludedNone: 'Энэ хугацааны бүх өдөр тооцоонд орсон.',
        excluded_holiday: 'Баярын өдөр',
        excluded_weekend: 'Амралтын өдөр',
        excluded_leave: 'Чөлөөтэй',
        excluded_work_mode: 'Батлагдсан цагийн бүртгэлтэй, гэвч тооцоонд ороогүй',
        excluded_not_approved: 'Цагийн бүртгэл батлагдаагүй',
        excluded_unaccounted: 'Тайлбаргүй',
        excluded_al_unrecorded: 'Ээлжийн амралт — энэ цалингийн хуудас аль өдрийг олгосныг бүртгээгүй',
        alPaidDates: 'Олгосон өдрүүд',
        workModeDays: 'Ажлын хэлбэрээр өдөр', leaveBreakdown: 'Амралтын задаргаа',
        notRecorded: 'Тодорхойгүй — энэ бүртгэлгүй үед баталгаажсан',
        none: 'Байхгүй',
        hoursSummary: 'Хугацаа тус бүрийн цаг',
        hoursByType: 'Цагийн төрлөөр',
        hourType_normal: 'Үндсэн цаг', hourType_overtime: 'Илүү цаг',
        hourType_night: 'Шөнийн цаг', hourType_over_night: 'Шөнийн илүү цаг',
        hourType_transit: 'Замын цаг',
        hoursWeighted:
          'Дээрх нийт цаг нь жинлэсэн дүн: төрөл бүр өөрийн итгэлцүүрээр ордог бөгөөд цалинтай чөлөө, нийтээр амрах өдрийг өдөрт 8 цагаар нэмж тооцно. Энд таны бүртгүүлсэн цагийг хэвээр нь харуулсан тул нийлбэр нь дээрх дүнтэй тэнцэхгүй.',
        paidTotal: 'Нийт олгосон', runNotIssued: 'Баталгаажаагүй',
        viewRunPayslip: '{{period}} — {{run}}: цалингийн хуудас харах',

        settlementsTitle: 'Амралтын тооцоо',
        settlementsHint:
          'Ажлаас чөлөөлөгдөх, жирэмсний амралт эсвэл хүсэлтээр хуримтлагдсан жилийн амралтыг мөнгөн дүнгээр нөхөн олгох хүсэлтүүд. Өөрийн гарын үсэг зурах шатыг зөвшөөрөх эсвэл татгалзана уу.',
        settlementPerson: 'Ажилтан', settlementTrigger: 'Төрөл',
        settlementDays: 'Өдөр', settlementDaysUnit: 'өдөр',
        settlementStatus: 'Төлөв', settlementCreated: 'Үүсгэсэн',
        settlementRelevantDate: 'Холбогдох огноо', settlementReason: 'Шалтгаан',
        settlementComment: 'Тайлбар', settlementRejectionHint: 'Татгалзах бол заавал бөглөнө',
        settlementCommentRequired: 'Татгалзахын тулд тайлбар шаардлагатай',
        settlementReject: 'Татгалзах', settlementApprove: 'Зөвшөөрөх',
        settlementDecided: 'Шийдвэр бүртгэгдлээ', settlementClose: 'Хаах',
        settlementTriggerResignation: 'Ажлаас чөлөөлөгдөх',
        settlementTriggerMaternity: 'Жирэмсний амралт',
        settlementTriggerOther: 'Хүсэлтээр',
        settlementStageManagement: 'Удирдлага', settlementStageFinance: 'Санхүү',
        settlementStatusApproved: 'Батлагдсан', settlementStatusRejected: 'Татгалзсан',
        settlementStatusPending: 'Хүлээгдэж буй',
        settlementFullWorking: 'Таны {{balance}} өдрийн үлдэгдлээс энэ жилийн {{allocation}} өдрийн эрхийн хараахан хуримтлагдаагүй {{unearned}} өдрийг хасав: {{countedTo}} хүртэлх {{yearDays}} ажлын өдрөөс {{worked}} өдөр нь {{earned}} өдрийг хуримтлуулна (баярын өдрийг тооцохгүй).',
        settlementFullNoLeavingDate: 'Хүний нөөцийн алба таны чөлөөлөгдөх огноог хараахан бүртгээгүй байна.',
        settlementFullNoBreakStart: 'Жирэмсний амралт эхлэх огноог оруулна уу.',
        settlementFullNoBreakOnRecord: 'Энэ өдөр эхлэх таны батлагдсан жирэмсний эсвэл хүүхэд асрах чөлөө бүртгэлд алга; амралтын эхлэх огноог оруулна уу.',
        settlementFullNoLeaveInfo: 'Танд бүртгэгдсэн жилийн амралтын эрх алга.',
        settlementFullAllocationUnknown: 'Таны жилийн амралтын эрхийн хэмжээ бүртгэгдээгүй тул тооцох боломжгүй; хүний нөөцийн албанд хандана уу.',
        settlementFullNothingToSettle: 'Тооцох хуримтлагдсан амралт алга.',
        settlementRequestHint:
          'Хуримтлагдсан жилийн амралтынхаа сонгосон өдрүүдийг мөнгөн дүнгээр авахыг хүснэ үү. Ажлаас гарахад хүний нөөцийн алба тооцоог хааж олгоно; жирэмсний амралтын олговрыг цалингийн алба амралт эхлэхэд автоматаар олгоно.',
        settlementSubmit: 'Хүсэлт илгээх', settlementMyRequests: 'Миний хүсэлтүүд',
        settlementRequested: 'Тооцооны хүсэлт илгээгдлээ',
        settlementStageSupervisor: 'Шууд удирдлага',
        settlementPreviewBalance: 'Жилийн амралт: {{before}} → {{after}} өдөр',
        settlementPreviewBalanceNow: 'Жилийн амралт: {{balance}} өдөр',
        settlementPreviewPending: 'Таны өмнө хүссэн {{days}} өдөр шийдвэр хүлээж байна.',
        settlementPreviewAmount: 'Тооцоолсон дүн: {{amount}} ({{days}} өдөр × {{dayValue}}), татвар суутгахаас өмнө. Эцсийн дүнг батлагдсан өдрөөр тооцно.',
        settlementPreviewPayDay: 'Олгох төлөвлөсөн өдөр: {{date}}, батлагдсаны дараах сүүлийн цалинтай хамт.',
        settlementPreviewOverMax: 'Та хамгийн ихдээ {{max}} өдөр хүсэх боломжтой.',
        settlementPreviewOverMaxReserve: 'Та хамгийн ихдээ {{max}} өдөр хүсэх боломжтой: энэ жилийн ээлжийн амралтад {{reserve}} өдөр нөөцлөгдөнө.',
        settlementRefusedContractor: 'Гэрээт ажилтанд мөнгөөр олгох жилийн амралт байхгүй.',
        settlementRefusedClosedOut: 'Таны амралтын тооцоо аль хэдийн хаагдсан.',
        settlementPaid: 'Олгогдсон',
        settlementAwaitingPay: 'Дараагийн сүүлийн цалинтай хамт',
        settlementsToDecide: 'Шийдэх амралтын тооцоо',
        payoutTag: 'Мөнгөөр олгох',
        payoutsAwaitingBadge: 'Таны шийдвэр хүлээж буй амралтын тооцоо: {{count}}',
        settlementAmount: 'Дүн',
        settlementYouSign: 'Таны шийдвэр дараах шатуудад гарын үсэг болно: {{stages}}',
      },
  },
  en: {
      payroll: {
        rates: {
          socialLoadFailed: 'Could not load the social insurance bands.',
          companyLoadFailed: 'Could not load the allowance versions.',
          versionSaveFailed: 'Could not save the version from {{date}}.',
          tab: 'Payroll rates',
          title: 'Company-wide payroll rates',
          subtitle:
            'The shared figures every net-pay calculation multiplies by — contribution percentages, the per-day allowances, and the ceiling contributions stop at.',
          effectTitle: 'What changing a rate reaches',
          effectIssued: 'Issued payslips do NOT move — they keep the figures they were paid with.',
          effectDrafts:
            'Every open draft run DOES re-derive from the new rates as soon as you save.',
          socialTitle: 'Social insurance bands',
          socialSubtitle:
            'The employee contribution and income-tax rate in force today for each code. Each row applies from its effective date; months before it keep the rate they had.',
          socialStatutory:
            'These rates are set by law and are the same for every organization. They cannot be edited here; they change with a system update.',
          socialEmpty: 'No social insurance bands recorded.',
          colCode: 'Code',
          colContribution: 'Employee contribution',
          colTax: 'Income tax',
          colDescription: 'Description',
          bandExists: 'Band “{{code}}” already exists — edit it in the table.',
          companyTitle: 'Allowances and the contribution ceiling',
          companySubtitle:
            'Versioned by the date they take effect. A calculation reads the most recent version in force for the month it is computing.',
          companyEmpty:
            'No rates recorded — allowances compute as zero and the contribution is uncapped.',
          colEffectiveSince: 'Effective since',
          colField: 'Field (F)',
          colBta: 'Trip abroad (BTA)',
          colBtl: 'Trip local (BTL)',
          colTransit: 'Transit (T)',
          colCap: 'Contribution ceiling',
          newVersionTitle: 'Add a new version',
          newVersionHint:
            'A new date is additive — months already computed keep the version they used. Choosing a date that already exists replaces that version instead.',
          versionExists: 'A version already exists for {{date}} — saving will replace it.',
          confirmVersion:
            'Replace the version effective {{date}}? Open draft runs from that date on will re-derive.',
          addVersion: 'Add version',
          replaceVersion: 'Replace version',
          saved: 'Rates saved.',
          invalidBlank: 'is empty',
          invalidNotANumber: 'must be a number',
          invalidNegative: 'cannot be negative',
          invalidAboveMaximum: 'cannot be above 100%',
          invalidTooPrecise: 'has more than 2 decimal places',
        },
        issue: 'Finalize', alreadyIssued: 'Finalized', status_Issued: 'Finalized', status_Draft: 'Draft',
        // Closing and reopening a payroll month.
        close: {
          action: 'Close payroll month',
          hint: 'Closing locks rejected time sheets from {{start}} to {{end}}.',
          confirm: 'Close payroll month {{month}}/{{year}}? Employees will no longer be able to correct rejected time sheets in it. Only an administrator can reopen it.',
          done: 'Payroll month {{month}}/{{year}} closed',
          closedBy: 'Payroll month {{month}}/{{year}} ({{start}} – {{end}}) was closed by {{name}} on {{when}}. Rejected time sheets in it are locked.',
          closed: 'Payroll month {{month}}/{{year}} ({{start}} – {{end}}) was closed on {{when}}. Rejected time sheets in it are locked.',
          reopen: 'Reopen month',
          reopenConfirm: 'Reopen payroll month {{month}}/{{year}}? This is recorded in the audit log.',
          reopened: 'Payroll month {{month}}/{{year}} reopened',
          notEnded: 'This month runs until {{end}}.',
          lockedWhy: 'This pay month is locked: it could change only until {{until}}.',
          notClosedLocked: 'Payroll month {{month}}/{{year}} was not closed: it is locked, past the last day it could change. Nothing was saved.',
        },
        clearOverride: 'Clear the override',
        noPayCalendar: 'No pay calendar for {{month}}/{{year}}, so its cut-offs are estimated from the pay-date rule: {{advance}} and {{final}}.',
        noPayCalendarEmpty: 'No pay calendar yet, so the cut-offs for {{month}}/{{year}} are estimated from the pay-date rule: {{advance}} and {{final}}. It is created by confirming this year under Admin, Config, Holiday calendar.',
        short: { amounts: 'Amounts', periods: 'Periods', info: 'Info', attention: 'Needs attention', futureLeave: 'Future leave', excel: 'Excel', settlements: 'Settlements' },
        showAmounts: 'Show amounts', hideAmounts: 'Hide amounts',
        blockedCount: '{{count}} people cannot be computed and will be left out of the run.',
        held: {
          pending: '{{count}} pending',
          rejected: '{{count}} rejected',
          title: '{{name}}: days not paid',
          explain: 'These days fall in this run and would have counted if they had been approved.',
          date: 'Date',
          hours: 'Hours',
          status: 'Status',
          statusPending: 'Pending',
          statusRejected: 'Rejected',
          open: 'Open on the time page',
          closeWarning: '{{count}} pending or rejected time days in this payroll month will not be paid. You can still close it.',
        },
        lateLogsTitle: 'Logs sent for approval after the cut-off',
        lateLogsNone: 'None.',
        lateLogThisPeriod: '{{name}} {{day}} ({{hours}} h), paid in this period',
        lateLogNextPeriod: '{{name}} {{day}} ({{hours}} h), rolls to {{period}}',
        monthBlockedNotice: 'Payroll for {{year}}-{{month}} is locked: a pay month can change only until the end of the month after it ({{until}}). Nothing in it can be edited, finalized, withdrawn or unlocked any more.',
        issuedRateMissingNotice: 'For {{count}} issued rows there was no company payroll rate on file for the period. The run is already issued and cannot change; check the rate record.',
        unpaidFiledNotice: '{{count}} people have filed days that no pay rate covers, so those days earn nothing: {{names}}. Backdate their rate, then recompute.',
        issuedSkipped: '{{count}} people were left out and stay unpaid until fixed: {{names}}',
        selectAll: 'Select everyone not yet finalized',
        selectPerson: 'Select {{name}}',
        finalizeSelected: 'Finalize ({{count}})',
        finalizedSelected: '{{count}} finalized: {{names}}',
        withdrawSelected: 'Withdraw ({{count}})',
        withdrawSelectedTitle: 'Withdraw the payslips of {{count}} people?',
        withdrawSelectedExplain:
          'No issued payslip is deleted — each keeps its figures and is marked withdrawn, and a corrected draft opens for each person, who moves back to Calculating. Any bonus, deduction or net adjustment carries over to the draft, and nothing is deducted as already paid.',
        withdrawnSelected: '{{count}} withdrawn: {{names}}',
        withdrawSkipped: '{{count}} not withdrawn (open the person to see why): {{names}}',
        calculatingAllIssued: 'Everyone in this run is finalized. They are listed under Issued.',
        bankExport: 'Bank export',
        bankExportWithheld: '{{count}} left out of the bank file and will not be paid: {{names}}',
        bankNoAccount: 'No bank account',
        bankNoPrimary: 'No main account',
        payslipNotSent: 'Payslip not sent yet',
        payslipSent: 'Payslip sent',
        payslipLanguage: 'Payslip language',
        payslipSentOn: 'Payslip sent on {{date}}',
        excelExportAdvance: 'Advance Excel',
        excelExportFinal: 'Final Excel',
        excelExportEmpty: 'Nothing to put in the sheet.',
        excelExportNoAccount: '{{count}} with no account on file, blank in the sheet: {{names}}',
        excelExportNoBank: 'Bank and account columns are blank: reading account numbers needs salary.edit.',
        excelExportLeftOut: '{{count}} flagged rows are not in the sheet: {{names}}',
        payslipsSent: '{{count}} payslips queued.',
        payslipsAlreadySent: '{{count}} payslips already went out — not sent again.',
        payslipsSuppressed:
          'No e-mail was sent: button-triggered email is switched off. Turn it on under Settings → Automation.',
        payslipsSkipped: '{{count}} not sent: {{names}}',
        noneComputed: 'Nobody in this run has a computed figure. Check Needs attention; people with nothing logged are not listed.',
        nothingLoggedCount: 'Nothing logged: {{count}}',
        reason: 'Reason',
        issuesTitle: 'Needs attention',
        issuesHint: 'Cannot be computed yet. The run cannot be finalized while anyone is here.',
        issuesNone: 'Nothing outstanding.',
        // The third list, and the opt-in that pays annual leave ahead.
        futureLeave: {
          title: 'Future leave',
          blockedFixed: 'Fixed salary, so it is not paid ahead.',
          hint: 'Leave that runs past this run’s cut-off, of every type, and which run pays the annual leave. Annual leave that starts before the next run’s cut-off can be added to this run.',
          none: 'No leave runs past this run’s cut-off.',
          person: 'Person',
          type: 'Type',
          dates: 'From – to',
          days: 'Working days',
          pay: 'Payroll',
          cancelPending: 'Withdrawal pending',
          paidBy: 'Paid by {{run}}',
          paidByUnknown: 'Paid by an issued run',
          willBePaidBy: 'Will be paid by {{run}}',
          eligible: 'Can be added to this run',
          added: 'Added to this run',
          add: 'Add to this run',
          remove: 'Take out of this run',
          addedToast: 'Added to this run.',
          removed: 'Taken out of this run.',
        },
        typicalShift: {
          loadFailed: 'Could not load the projects.',
          saveFailed: 'Could not save the typical hours for “{{project}}”.',
          title: 'Typical shift hours per project',
          subtitle: 'The most a downtime day pays on this project: worked hours plus paid downtime stop at this figure. Applies to work days from 2026-09-24. Defaults to 11.',
          product: 'Project',
          hours: 'Typical hours',
          save: 'Save',
          saved: 'Typical shift hours saved.',
          invalid: 'Enter a number above 0 and at most 24 (up to 2 decimals).',
          empty: 'No projects.',
          inactive: 'inactive',
        },
        taskRules: {
          loadFailed: 'Could not load the task rate rules.',
          newSetOpen: 'The new rule set form is already open.',
          createFailed: 'Could not create the rule set.',
          title: 'Task rate rules',
          subtitle: 'Tiered pay per task or unit. The day\'s count picks ONE tier and every unit that day is paid at that tier\'s rate. The count resets each day.',
          effectNotice: 'Editing a version reprices open (unissued) drafts from its effective date. Issued payslips never move. The safe change is to add a new effective date.',
          archiveFailed: 'Could not change {{name}}.',
          deleteFailed: 'Could not delete the {{date}} version of {{name}}.',
          unchanged: 'Nothing has changed yet.',
          loading: 'Loading rule sets…',
          empty: 'No task rate rules yet.',
          newSet: 'New rule set',
          setName: 'Name',
          unitLabel: 'Unit label',
          unitLabelHint: 'Shown on payslips as typed, for example "box". Not translated.',
          createSet: 'Create rule set',
          assigned: '{{n}} assigned',
          archivedBadge: 'Archived',
          archive: 'Archive',
          unarchive: 'Restore',
          noVersions: 'No tiers yet. Add the first effective date below.',
          colEffectiveSince: 'Effective since',
          colFrom: 'From',
          colTo: 'To',
          colRate: 'Rate per unit',
          openEnded: 'and above',
          addDate: 'Add new effective date',
          addDateHint: 'A new date is additive: earlier days keep the tiers they were priced with. The first tier must start at 1; each "to" follows from the next "from".',
          editVersion: 'Edit this date',
          addTier: 'Add tier',
          removeTier: 'Remove tier',
          saveNew: 'Add effective date',
          saveReplace: 'Replace this version',
          cancel: 'Cancel',
          versionExists: 'A version already exists for {{date}} — saving will replace it and reprice open drafts.',
          confirmOverwrite: 'Replace the {{date}} version? Open drafts from that date will be repriced.',
          deleteVersion: 'Delete this date',
          confirmDelete: 'Delete the {{date}} version? Open drafts from that date will be repriced.',
          saved: 'Rule set saved.',
          effectiveRequired: 'Choose an effective date.',
          nameRequired: 'Enter a name.',
          previewTitle: 'Preview a day',
          previewCount: 'Units in the day',
          previewResult: '{{n}} × {{rate}} = {{pay}} (tier from {{min}})',
          previewNone: 'A day with no units pays nothing.',
          decreasingHint: 'Tier {{row}} pays less per unit than the one before it. That is allowed; check it is intended.',
          invalid_empty: 'Add at least one tier.',
          invalid_blank: 'Tier {{row}}: fill in both the count and the rate.',
          invalid_not_a_number: 'Tier {{row}}: enter numbers.',
          invalid_not_whole: 'Tier {{row}}: the count must be a whole number.',
          invalid_negative_rate: 'Tier {{row}}: the rate cannot be negative.',
          invalid_too_precise: 'Tier {{row}}: the rate can have at most 2 decimal places.',
          invalid_first_not_one: 'The first tier must start at 1.',
          invalid_not_increasing: 'Tier {{row}}: the count must be higher than the tier above.',
          segPay: 'Task pay',
          segUnitDefault: 'tasks',
        },
        warn: {
          rate_missing: 'No pay rate on record',
          payroll_rate_missing: 'No company payroll rate on file for this period',
          shift_source_missing: 'No shift data (the roster has no backend yet)',
          social_band_missing: 'Social insurance band not found',
          leave_factor_missing: 'No twelve-month history, so annual leave has no daily average',
          pay_basis_unrecognised: 'Unrecognised pay basis on the rate record',
          task_rule_version_missing: 'Task rule set has no version in force on a worked day, so that day was priced 0',
          unpaid_filed_days: '{{count}} filed day(s) earn nothing because no pay rate covers them: {{days}}',
          cl_year_end_unpriced: 'No pay rate on record, so the year-end payout for unused leave was not priced',
          psl_year_end_reset_missing: "Last year's 31 Dec leave reset has not run, so no unused PSL is paid in this final",
          contractor_entry_unpriced: 'An approved contractor log entry falls on a date without a Daily+Hourly rate, so it was not paid',
          final_issued: "This month's final was issued before the advance, so the advance is not issued",
          break_payout_balance_short: 'The AL, CL or PSL balance is below what the break pay-out settled when it was raised, so it is not issued: void the break pay-out and settle by hand',
          break_payout_leave_row_changed: 'The leave balances were re-granted since the break pay-out was raised, so it is not issued: void the break pay-out and settle by hand',
        },
        period: 'Pay period', people: 'People', totalGross: 'Total gross', gross: 'Gross',
        company: 'Company', model: 'Model', modelDaily: 'Daily', modelFixed: 'Fixed', modelHourly: 'Hourly',
        rate: 'Rate', worked: 'Worked (h/shifts)',
        run: 'Run', run_advance: 'Advance', run_final: 'Final',
        mode: 'Mode', mode_calculating: 'Calculating', mode_issued: 'Finalized',
        selectAllIssued: 'Select everyone issued',
        noneIssued: 'Nobody in this run is issued yet.',
        sendPayslip: 'Send payslip ({{count}})',
        sendPayslipTitle: 'Email a payslip to {{count}} people?',
        sendPayslipExplain: 'Anyone already sent this payslip does not get a second copy; a payslip that was withdrawn, corrected and re-issued is sent again. Mail cannot be recalled once sent.',
        covers: 'Covers {{start}} → {{end}}',
        heading: {
          progress: '{{month}} {{run}} — {{issued}} issued, {{left}} left',
          notIssued: '{{month}} {{run}} — not issued yet, cut-off {{cutOff}}',
          notIssuedNoCut: '{{month}} {{run}} — not issued yet',
        },
        social: 'Social insurance', tax: 'Income tax', net: 'Net',
        advance: 'Advance', remainder: 'Remainder',
        totalAdvance: 'Total advance', totalRemainder: 'Total remainder', totalNotKnown: 'Not known',
        advancePaid: 'Advance already paid',
        // The one reason a final run's remainder computes to exactly 0: the
        // advance already paid the whole net. A bare "0" reads as nothing paid.
        settledByAdvance: 'Paid in full by the advance (gross {{gross}})',
        advanceAdjustment: 'Adjustment carried from the advance',
        netAdjustment: 'Adjustment (after tax)',
        clYearEndPay: 'Unused PSL payout',
        payNote: {
          pslPriced: 'PSL {{days}} days x 8h x {{rate}} = {{amount}}',
          pslLapseFixed: 'PSL {{days}} days ({{year}}) lapse unpaid on a fixed salary',
          breakNetZero: 'CL award {{award}} days less {{back}} taken back nets to 0 days',
          breakUnpaidFixed: 'CL/PSL {{days}} days settle unpaid on a fixed salary',
          breakUnpaid: 'CL/PSL {{days}} days settle unpaid',
        },
        activityBonus: 'Activity-fund bonus',
        loadFailed: 'This run could not be loaded.',
        activityWorking: '{{months}} months paid · {{points}} points × {{rate}} = {{total}}',
        activityNoMonths: 'No months paid into the fund that year',
        activityFund: {
          mark: 'Pay it in this run',
          unmark: 'Remove the mark',
          unmarked: 'This final run does not pay the {{fundYear}} activity fund',
          marked: 'This final run pays the {{fundYear}} activity fund: points × the monthly contribution',
          elsewhere: 'The {{fundYear}} activity fund is paid by the {{year}}-{{month}} final run',
          off: 'The activity-fund bonus is switched off for this organization until its tax treatment is settled',
          hint: 'One final run a year is marked. It pays each person the points for the months they paid into the fund in {{fundYear}}, times the monthly contribution. The figure is not typed: correct it in the fund grid and the run recomputes.',
          markConfirm: 'Pay the {{fundYear}} activity fund in this final run?',
          unmarkConfirm: 'Take the {{fundYear}} activity fund off this final run?',
          markDone: 'This run now pays the {{fundYear}} activity fund',
          unmarkDone: 'This run no longer pays the {{fundYear}} activity fund',
          blocked: {
            future: 'A run in a future year cannot be marked',
            issued: 'This run has issued payslips; void them first',
            locked: 'This month is closed or locked',
          },
        },
        breakAlPay: 'Break start or Full Time switch: AL earned (after tax)',
        breakClPslPay: 'Of which CL/PSL settled at a break start or Full Time switch (taxed as salary)',
        leavePayoutOfWhich: 'Of which unused leave paid out on leaving',
        alSettlementOfWhich: 'Of which annual leave paid out at your request',
        // The employee's own payslip portal
        paidOut: 'Paid',
        viewPayslip: 'View',
        shiftsN: '{{count}} shifts', hoursN: '{{count}} h',
        shiftsUnit: 'shifts', tasksUnit: 'tasks', hoursUnit: 'h',
        socialTag: 'Social tag {{tag}}',
        socialAt: 'Social insurance {{percent}}%', taxAt: 'Income tax {{percent}}%',
        socialCapped: 'Capped: social insurance stops accruing above {{cap}}.',
        segmentTotal: 'Segments', segmentGross: 'Segment gross', allowances: 'Allowances',
        p73: {
          help: "Explain",
          reportedHours: "Reported hours",
          weightedHours: "Weighted hours",
          reportedShifts: "Reported shifts",
          weightedShifts: "Paid shifts",
          hoursTitle: "Hours: reported (weighted)",
          paidLeave: "Paid leave (PSL / CL / SPL)",
          annualLeave: "Annual leave (AL)",
          annualLeaveDays: "{{days}} d · {{hours}} h",
          shiftsTitle: "Shifts: reported (paid)",
          taskTotal: "{{count}} tasks = {{amount}}",
          taskDatesUnavailable: "The per-date task lines were not kept for this run, so they cannot be shown. The total above is the payroll’s own.",
          t60: "Transit, credited at 60%",
          totals: "Total",
          normalHint: "H, DT and PD are paid as one figure: H {{h}} · DT {{dt}} · PD {{pd}}",
          gap: "The days above come to {{sign}}{{gap}} h off the payroll total — a carried-over day can do that.",
          hoursHelp: "Each cell: hours reported (hours weighted). Weights: overtime 1.5, night 1.2, night + OT 1.8, transit 0.6. PD is capped at 10% of the work that day; downtime counts at 60% and from 2026-09-24 is capped at the typical shift hours of the project. H, DT and PD are rounded as one figure. The total line is the payroll’s own figure; paid leave and holiday count 8 h a day. On a fixed salary day pay does not follow the hours.",
          shiftsHelp: "Each date: shifts reported (shifts paid). A transit (T) shift is paid at 60%. The total is the payroll’s own shift count. Paid shifts are split by kind: D day, N night, L logging, T transit (×0.6), DT downtime (×0.6).",
          formulaHelp: "Each line is count × factor × rate. A factor shows only when it divides the rate exactly. The lines must add up to the gross. A Daily segment with a second (additional) rate shows as one line without count × rate: the stored breakdown does not record which shifts were paid at which rate.",
          figuresHelp: "Social insurance = min(gross, cap) × its percent; the cap and percent come from the social-insurance code on the rate in force on the period’s final cut-off day. Income tax = (gross − social insurance) × the tax percent. An exemption sets that percent to 0 for the month.",
          socialBaseCapped: "Base: min(gross {{gross}}, cap {{cap}}) = {{base}}",
          socialBaseGross: "Base: gross {{base}} (no cap set)",
          baseNotRecorded: "Base: not recorded on an issued payslip",
          taxBase: "Income tax base (gross − social insurance)",
          figuresTitle: "Final figures",
          exemptSocial: "Exempt from social insurance (0%)",
          exemptTax: "Exempt from income tax (0%)",
          ratePeriods: "Rate periods ({{count}})",
        },
        dayHours: {
          day: 'Day', ordinary: 'Ordinary', downtime: 'Downtime', pd: 'PD',
          total: 'Day total',
          carried: 'prior month', fixed: 'fixed salary',
          notRecorded: 'This run was issued before hours per day were recorded.',
          
        },
        frozenAtIssue: 'The working as it was frozen when this run was issued. It does not follow later timesheet corrections.',
        carryOver: 'A prior-month day, approved after that month was issued. Paid now at the rate that was in force on the day itself.',
        noFrozenBreakdown: 'This issued row was stored without a breakdown, so nothing here accounts for the figures below.',
        ledgerSegment: 'Advance ledger',
        ledgerSegmentWhy: 'An advance has no pay basis and no rate of its own — this is the record of which days it paid for. The rate is on the final run.',
        monthFigureHint: 'Gross, social insurance and income tax are the whole month’s; Advance and Final are the net paid in each instalment.',
        correctionsTitle: 'Correction history',
        correctionsNone: 'Nothing has been withdrawn for this month.',
        withdraw: 'Withdraw and reopen',
        withdrawConfirm: 'Withdraw',
        withdrawReason: 'Why it is being withdrawn',
        withdrawExplain:
          'The issued payslip is not deleted — it keeps its figures, is marked withdrawn, and a corrected draft opens beside it. Any bonus, deduction or net adjustment carries over to the draft, and nothing is deducted as already paid.',
        withdrawn: 'Payslip withdrawn; a corrected draft is open.',
        withdrawnLabel: 'Withdrawn',
        withdrawnBecause: 'Reason: {{reason}}',
        p83: {
          workedHint: "Hours (or shifts) worked + the leave this run pays. * = annual leave paid ahead",
          partHours: "Hours worked: {{value}}",
          partShifts: "Shifts worked: {{value}}",
          partTasks: "Tasks done: {{value}}",
          partLeave: "{{code}}: {{value}} h of paid leave, counted in the hours",
          partAl: "Annual leave: this run pays {{value}} days",
          aheadHint: "* paid ahead — the leave starts after this period",
          annualLeaveAhead: "Annual leave, paid ahead",
        },
        p70: {
          carryNoRun: "Last month's final never paid this person, so this day is paid in this run.",
          formulaSince: "(from {{date}})",
          carriedLeave: "Late-approved leave: {{leave}} d",
          segmentHolidays: "Holidays: {{dates}}",
          colModeDays: "Days (F/T)",
          modeDaysHint: "Days worked this period: F field, T transit, BTA business trip abroad, BTL business trip local",
          modeChipHint: "{{code}}: {{days}} days",
          transitNotOnRate: "T: not on rate",
          transitNotOnRateHint: "There are transit days, but this person's rate carries no transit allowance.",
          formulaTitle: "How the gross is made",
          formulaMismatch: "The terms don't add up to the gross — tell the payroll team.",
          colLeave: "Leave (CL/PSL/SPL/AL)",
          leaveWaiting: "Leave: waiting for server",
          leaveTotalsLead: "This period:",
          leaveTotalsItem: "{{code}} {{days}} d ({{people}} people)",
          chipHint: "{{code}} {{days}} days — open their leaves",
          chipUnpaidHint: "{{code}} {{days}} days, some not paid — open their leaves",
          taskValue: "Task pay",
          info: {
            badgeHint: "{{count}} people with leave or carried-over time",
            button: "Period info",
            title: "This pay period",
            holidays: "Holidays in this pay period",
            noHolidays: "No holidays in this pay period.",
            notReported: "Not reported",
            carried: "Previous-period money in this run",
            noCarried: "Nobody has money from an earlier period in this run.",
            carriedLeaveNotReported: "Late-approved leave (P67) is not reported separately yet — it may be among the dates above.",
            other: "Other things that change pay",
            draft: "Draft",
            issued: "Finalized",
            issues: "Cannot be computed",
            leaversNotReported: "Leavers, joiners and volunteers are not reported by the server yet.",
            fact: {
              unlocked: "Paid advance unlocked",
              taxExempt: "Exempt from income tax",
              socialExempt: "Exempt from social insurance",
              grossOverride: "Gross overridden by hand",
              figuresUnrecorded: "Figures not recorded (import)",
            },
            prevTime: "Carried-over time",
            prevUnpaidFiled: "Filed days no rate covers, paid nothing: {{dates}}",
            prevNoRun: "{{period}} final never paid them — that window is paid here: {{days}} d",
            prevNoRunAl: "AL {{days}} d",
            prevNoRunHours: "{{hours}} h",
          },
          leavesTitle: "Leave this payroll",
          leavesCaveat: "Only people on this payroll are listed — a leaver or volunteer who is not on the list does not appear.",
          leavesNone: "Nobody had a leave this payroll.",
          leavesUnknown: "The server does not report leaves yet.",
          colName: "Name",
          colType: "Leave type",
          colDates: "Dates",
          colDays: "Days",
          colPaid: "How it was paid",
          leaveCountHint: "Leave days this period: CL / PSL / SPL / AL",
          groupFullTime: "Full time",
          groupRest: "Other work types",
          workedPlusLeave: "Worked + leave: {{dates}}",
          personLeavesTitle: "Leaves in this period",
          personLeavesNone: "No leave in this period.",
          personLeavesUnlisted: "Only leave payroll does not count here, such as RL or UL.",
          uncountedLeave: "Leave, 0 days",
          uncountedLeaveHint: "Approved leave falls in this period, but no day of it counts in this run — open their leaves",
          halfDay: "half day",
          part: {
            normal: "Normal",
            overtime: "Overtime",
            night: "Night",
            over_night: "Night + OT",
            transit: "Transit",
            leave: "Paid leave",
            holiday: "Holiday",
          },
          treatment: {
            paid: "Paid",
            partly_paid: "Partly paid ({{paid}} of {{days}} days)",
            over_annual_cap: "Over the annual cap — not paid",
            annual_leave: "Annual leave (paid as leave pay)",
            covered_by_fixed_salary: "Covered by fixed salary",
            not_paid: "Not paid",
            not_recorded: "Not recorded",
            al_other_run: "Paid by another run",
          },
        },
        p62: {
          decisionsTitle: 'Decisions',
          unlock: 'Unlock',
          unlockConfirm: 'Unlock',
          unlockReason: 'Why it is being unlocked',
          unlockExplain: 'A paid advance is locked against withdrawal. Unlocking it is deliberate and is recorded with its reason.',
          unlocked: 'Advance unlocked.',
          lockedNote: 'This advance is paid, so it is locked. Unlock it, with a reason, before withdrawing it.',
          unlockedNote: 'Unlocked. Reason: {{reason}}',
          advanceLocked: 'This advance is paid and locked. Unlock it with a reason first.',
          finalIssued: 'The {{month}} final is already issued and deducted this advance. Void the final first.',
          oneOffIssued: 'A {{month}} one-off payslip is already issued and used part of the social-insurance cap for that month. Void and reissue the one-off first, then issue it again once this payslip is reissued.',
          laterIssued: 'The {{month}} {{run}} payslip is issued after this one. Only the latest payslip can be voided, so void that one first.',
          awaitingReissueAsk: 'The advance of {{names}} was voided and not reissued yet, so their final cannot be issued. Issue the final for the others now?',
          oneOffFirst: 'A {{month}} one-off payslip is already issued and used part of the social-insurance cap for that month. Void and reissue the one-off first, then issue it again after this final.',
          oneOffFirstAsk: '{{names}} already have an issued one-off payslip this month, so their final cannot be issued until it is voided and reissued. Issue the final for the others now?',
          issueOthers: 'Finalize the others',
          advanceAwaitingReissue: 'The {{month}} advance was voided and not reissued yet. Reissue it before issuing the final.',
          monthClosed: 'Payroll for {{month}} is closed. An administrator must reopen the month before this can change.',
          monthNoFinalPeriod: 'The calendar holds no final pay period for {{month}}. Add it before closing the month.',
          exemptTitle: 'Tax and social insurance exemption',
          exemptHint: 'Applies to every month whose period starts on or after the date. Issued payslips do not change. To end an exemption, add a row with both switches off.',
          exemptTax: 'Exempt from income tax',
          exemptSocial: 'Exempt from social insurance',
          exemptNeither: 'no exemption',
          exemptSince: 'Effective from',
          exemptReason: 'Reason',
          exemptAdd: 'Add an exemption',
          exemptSave: 'Save',
          exemptSaved: 'Exemption saved.',
          exemptDelete: 'Delete',
          exemptRow: 'From {{since}}: {{what}} — {{reason}}',
          exemptInForce: 'In force this month: {{what}}',
          calendarUnconfirmed: 'Payroll for this month cannot start until the calendar for {{years}} is confirmed. Confirm the year first.',
          openCalendar: 'Open the calendar',
          onePerMonth: '{{field}} is already set on this month’s {{run}} run. Only one is allowed per month — clear it there first.',
          field_bonus: 'Bonus',
          field_deduction: 'Pre-tax deduction',
          field_net_adjustment: 'After-tax deduction',
        },
        leaveTopUp: 'Annual leave: {{days}} d × {{factor}}',
        leaveInFixed: 'Not added: the month ends on a fixed salary, which already covers those days.',
        bonus: 'Bonus', deduction: 'Deduction', note: 'Note',
        shifts: 'Shifts', includedDays: 'Days counted', alDays: 'AL days',
        byHand: 'Calculated by hand', models: 'Pay model', overrideValue: 'Gross override',
        grossSetByPayroll: 'Gross (set by payroll)', notApplied: '{{amount}} — not applied',
        allowancesNotApplied: 'Not applied: payroll set the gross for this payslip.',
        proration: 'Working days in segment / month', reportedHours: 'Reported hours',
        weightedHours: 'Weighted hours',
        perDaily: 'per shift', perHourly: 'per hour', perFixed: 'per month',
        branchAdditionalShort: 'Second rate {{rate}}: logging and downtime at full weight, transit at 0.6.',
        branchRateShort: 'Base rate: logging at full weight, downtime and transit at 0.6.',
        periods: 'Pay periods',
        periodsHint: 'The pay calendar this run computes from, and the boundary self-service edits and admin corrections in Time & Leave cannot reach past. Until now it was import-only.',
        periodsRunningLow: 'The pay calendar ends on {{date}}. After that only a time admin can change or approve actual time. Confirm next year on the holiday calendar and generate its periods before then.',
        periodsEnded: 'The pay calendar ended on {{date}}, so only a time admin can change or approve actual time. Confirm the next year on the holiday calendar and generate its periods.',
        periodsGenerate: 'Generate the next periods',
        periodsGenerateHint: 'Computed from the pay-date rule: pay lands on the last working day on or before the 11th and the 26th, and the cut-off is two days before that. Public holidays and weekends move the pay date; the cut-off follows it and may itself fall on a weekend. These dates are not editable — to move one, correct that year’s holidays on the holiday calendar.',
        periodsYearNotConfirmed: 'The holiday calendar has not been confirmed for {{years}}, so the dates shown for those months were worked out from weekends alone and would miss every public holiday. Confirm {{years}} on the holiday calendar, or choose fewer months.',
        periodsPropose: 'Propose',
        periodsHowMany: 'How far ahead',
        periodsMonthsN: '{{count}} months',
        periodsProposedNote: '{{note}}',
        periodsNothingToAdd: 'No new months to add.',
        tickFirst: 'Tick at least one person first.',
        busyWhy: 'Working…',
        firstPage: 'Already on the first page',
        lastPage: 'Already on the last page',
        nothingToExport: 'There are no rows to export',
        noPeriodLoaded: 'The period has not loaded yet',
        rowLocked: 'This row is issued, or you may not edit it',
        tickOtherMode: 'This person belongs to the other view',
        closeUnknown: 'The end of the period is not known yet',
        reasonFirst: 'Write a reason first.',
        dateAndReasonFirst: 'Fill in the date and the reason first.',
        periodsLoadFailed: 'The pay calendar could not be loaded.',
        periodsProposeFailed: 'The proposed months could not be loaded.',
        periodsSaveFailed: 'Nothing was added to the pay calendar.',
        periodsGenerateSave: 'Save {{count}} periods',
        periodsGenerated: '{{count}} periods added to the pay calendar.',
        periodsEmpty: 'No pay calendar yet. It is created by confirming this year under Admin, Config, Holiday calendar.',
        periodsReadOnly: 'You can view the pay calendar but not change it.',
        periodsMonth: 'Month',
        periodsPayDate: 'Pay date',
        periodsCutOff: 'Cut-off',
        daysPaid: 'Days paid', shiftDaysPaid: 'Shift days paid',
        holidaysCredited: 'Public holidays credited (8 h each)',
        excludedDays: 'Days not paid',
        excludedNone: 'Every day in this period was paid.',
        excluded_holiday: 'Public holiday',
        excluded_weekend: 'Weekend',
        excluded_leave: 'On leave',
        excluded_work_mode: 'Timesheet approved but not in this run',
        excluded_not_approved: 'Timesheet not approved',
        excluded_unaccounted: 'No record explains this day',
        excluded_al_unrecorded: 'Annual leave — this payslip did not record which dates it paid',
        alPaidDates: 'Dates paid',
        workModeDays: 'Days by work mode', leaveBreakdown: 'Leave breakdown',
        notRecorded: 'Cannot tell — issued before this was tracked',
        none: 'None',
        hoursSummary: 'Hours by segment',
        hoursByType: 'Hours by type',
        hourType_normal: 'Ordinary', hourType_overtime: 'Overtime',
        hourType_night: 'Night', hourType_over_night: 'Overtime at night',
        hourType_transit: 'Transit',
        hoursWeighted:
          'The total above is weighted: each type counts at its own rate, and paid leave and public holidays are credited at 8 hours a day. These are the hours as you logged them, so they do not add up to it.',
        paidTotal: 'Paid in total', runNotIssued: 'Not finalized',
        viewRunPayslip: '{{period}} {{run}} — view payslip',

        settlementsTitle: 'Leave settlements',
        settlementsHint:
          'Requests to pay out accrued annual leave on resignation, maternity leave, or by request. Approve or reject each stage you sign.',
        settlementPerson: 'Employee', settlementTrigger: 'Type',
        settlementDays: 'Days', settlementDaysUnit: 'days',
        settlementStatus: 'Status', settlementCreated: 'Raised',
        settlementRelevantDate: 'Relevant date', settlementReason: 'Reason',
        settlementComment: 'Comment', settlementRejectionHint: 'Required when rejecting',
        settlementCommentRequired: 'A rejection needs a comment',
        settlementReject: 'Reject', settlementApprove: 'Approve',
        settlementDecided: 'Decision recorded', settlementClose: 'Close',
        settlementTriggerResignation: 'Resignation',
        settlementTriggerMaternity: 'Maternity leave',
        settlementTriggerOther: 'By request',
        settlementStageManagement: 'Management', settlementStageFinance: 'Finance',
        settlementStatusApproved: 'Approved', settlementStatusRejected: 'Rejected',
        settlementStatusPending: 'Pending',
        settlementFullWorking: 'Your balance of {{balance}} days, less the {{unearned}} days of this year’s {{allocation}}-day grant not yet earned: {{worked}} of {{yearDays}} working days to {{countedTo}} earn {{earned}} (holidays excluded).',
        settlementFullNoLeavingDate: 'HR has not recorded your leaving date yet.',
        settlementFullNoBreakStart: 'Enter the date your maternity leave starts.',
        settlementFullNoBreakOnRecord: 'No approved maternity or child care leave of yours starts on that date; enter the day your approved leave starts.',
        settlementFullNoLeaveInfo: 'You have no annual leave entitlement on record.',
        settlementFullAllocationUnknown: 'Your yearly annual leave grant is not on record, so the figure cannot be worked out; ask HR.',
        settlementFullNothingToSettle: 'There is no earned annual leave to settle.',
        settlementRequestHint:
          'Ask to be paid out the days of accrued annual leave you choose. When you leave, HR pays your leave in the close-out; payroll pays maternity leave automatically when it starts.',
        settlementSubmit: 'Submit request', settlementMyRequests: 'My requests',
        settlementRequested: 'Settlement requested',
        settlementStageSupervisor: 'Supervisor',
        settlementPreviewBalance: 'Annual leave: {{before}} → {{after}} days',
        settlementPreviewBalanceNow: 'Annual leave: {{balance}} days',
        settlementPreviewPending: '{{days}} days you already asked for are still waiting for a decision.',
        settlementPreviewAmount: 'Estimated pay: {{amount}} ({{days}} days × {{dayValue}}), before tax. The final figure is priced on the day it is approved.',
        settlementPreviewPayDay: 'Estimated pay day: {{date}}, with the final pay after approval.',
        settlementPreviewOverMax: 'You can ask for at most {{max}} days.',
        settlementPreviewOverMaxReserve: 'You can ask for at most {{max}} days: {{reserve}} days stay reserved for this year’s leave block.',
        settlementRefusedContractor: 'Contractors hold no annual leave to pay out.',
        settlementRefusedClosedOut: 'Your leave has already been closed out.',
        settlementPaid: 'Paid',
        settlementAwaitingPay: 'With the next final pay',
        settlementsToDecide: 'Pay-outs to decide',
        payoutTag: 'Pay-out',
        payoutsAwaitingBadge: 'Leave pay-outs waiting for your decision: {{count}}',
        settlementAmount: 'Amount',
        settlementYouSign: 'Your decision signs: {{stages}}',
      },
  },
  ru: {
      payroll: {
        rates: {
          socialLoadFailed: 'Не удалось загрузить коды соцстрахования.',
          companyLoadFailed: 'Не удалось загрузить версии надбавок.',
          versionSaveFailed: 'Не удалось сохранить версию от {{date}}.',
          tab: 'Ставки по зарплате',
          title: 'Общие ставки по зарплате',
          subtitle:
            'Общие показатели, на которые опирается расчёт любой зарплаты, — проценты взносов, суточные надбавки и предельная база для взносов.',
          effectTitle: 'На что влияет изменение ставки',
          effectIssued:
            'Выданные расчётные листы НЕ меняются — в них остаются выплаченные суммы.',
          effectDrafts:
            'Все черновики (Draft) пересчитываются по новым ставкам сразу после сохранения.',
          socialTitle: 'Ставки социального страхования',
          socialSubtitle:
            'Взнос работника и ставка НДФЛ, действующие сегодня для каждого кода. Каждая строка действует с даты начала; более ранние месяцы сохраняют прежнюю ставку.',
          socialStatutory:
            'Эти ставки установлены законом и одинаковы для всех организаций. Здесь их изменить нельзя — они меняются с обновлением системы.',
          socialEmpty: 'Коды социального страхования не заданы.',
          colCode: 'Код',
          colContribution: 'Взнос работника',
          colTax: 'НДФЛ',
          colDescription: 'Описание',
          bandExists: 'Код «{{code}}» уже существует — измените его в таблице.',
          companyTitle: 'Надбавки и предельная база взносов',
          companySubtitle:
            'Версии по дате вступления в силу. Расчёт берёт последнюю версию, действовавшую в расчётном месяце.',
          companyEmpty:
            'Ставки не заданы — надбавки считаются нулевыми, а взнос не ограничен.',
          colEffectiveSince: 'Действует с',
          colField: 'Поле (F)',
          colBta: 'Загранкомандировка (BTA)',
          colBtl: 'Местная командировка (BTL)',
          colTransit: 'Транзит (T)',
          colCap: 'Предельная база взносов',
          newVersionTitle: 'Добавить новую версию',
          newVersionHint:
            'Новая дата только добавляет версию — уже рассчитанные месяцы сохраняют свою. Существующая дата заменяет её версию.',
          versionExists: 'Версия на {{date}} уже есть — сохранение заменит её.',
          confirmVersion:
            'Заменить версию, действующую с {{date}}? Черновики с этой даты будут пересчитаны.',
          addVersion: 'Добавить версию',
          replaceVersion: 'Заменить версию',
          saved: 'Ставки сохранены.',
          invalidBlank: 'не заполнено',
          invalidNotANumber: 'должно быть числом',
          invalidNegative: 'не может быть отрицательным',
          invalidAboveMaximum: 'не может превышать 100%',
          invalidTooPrecise: 'более 2 знаков после запятой',
        },
        issue: 'Утвердить расчёт', alreadyIssued: 'Утверждён', status_Issued: 'Утверждён', status_Draft: 'Черновик',
        // Закрытие и повторное открытие расчётного месяца.
        close: {
          action: 'Закрыть расчётный месяц',
          hint: 'Закрытие заблокирует отклонённые табели с {{start}} по {{end}}.',
          confirm: 'Закрыть расчётный месяц {{month}}/{{year}}? Сотрудники больше не смогут исправлять в нём отклонённые табели. Открыть его снова может только администратор.',
          done: 'Расчётный месяц {{month}}/{{year}} закрыт',
          closedBy: 'Расчётный месяц {{month}}/{{year}} ({{start}} – {{end}}) закрыт: {{name}}, {{when}}. Отклонённые табели в нём заблокированы.',
          closed: 'Расчётный месяц {{month}}/{{year}} ({{start}} – {{end}}) закрыт {{when}}. Отклонённые табели в нём заблокированы.',
          reopen: 'Открыть месяц снова',
          reopenConfirm: 'Снова открыть расчётный месяц {{month}}/{{year}}? Это будет записано в журнал аудита.',
          reopened: 'Расчётный месяц {{month}}/{{year}} снова открыт',
          notEnded: 'Этот месяц длится до {{end}}.',
          lockedWhy: 'Этот расчётный месяц заблокирован: менять его можно было только до {{until}}.',
          notClosedLocked: 'Расчётный месяц {{month}}/{{year}} не закрыт: он заблокирован, срок изменений истёк. Ничего не сохранено.',
        },
        clearOverride: 'Убрать ручное значение',
        noPayCalendar: 'Календарь выплат за {{month}}/{{year}} не задан — даты отсечки рассчитаны по правилу: {{advance}} и {{final}}.',
        noPayCalendarEmpty: 'Календаря выплат пока нет, поэтому даты отсечки за {{month}}/{{year}} рассчитаны по правилу: {{advance}} и {{final}}. Он создаётся при подтверждении текущего года в разделе Администрирование, Конфигурация, Календарь праздников.',
        short: { amounts: 'Суммы', periods: 'Периоды', info: 'Инфо', attention: 'Внимание', futureLeave: 'Отпуска', excel: 'Excel', settlements: 'Расчёты' },
        showAmounts: 'Показать суммы', hideAmounts: 'Скрыть суммы',
        blockedCount: 'Не удаётся рассчитать сотрудников: {{count}} — они не войдут в расчёт.',
        held: {
          pending: 'на утверждении: {{count}}',
          rejected: 'отклонено: {{count}}',
          title: '{{name}}: неоплаченные дни',
          explain: 'Эти дни входят в этот расчёт и были бы учтены, если бы их утвердили.',
          date: 'Дата',
          hours: 'Часы',
          status: 'Статус',
          statusPending: 'На утверждении',
          statusRejected: 'Отклонён',
          open: 'Открыть на странице учёта времени',
          closeWarning: 'Дней на утверждении или отклонённых в этом расчётном месяце: {{count}}; они не будут оплачены. Закрыть месяц всё равно можно.',
        },
        lateLogsTitle: 'Записи, отправленные на утверждение после даты отсечки',
        lateLogsNone: 'Нет.',
        lateLogThisPeriod: '{{name}} {{day}} ({{hours}} ч), оплачивается в этом периоде',
        lateLogNextPeriod: '{{name}} {{day}} ({{hours}} ч), переносится на {{period}}',
        monthBlockedNotice: 'Зарплата за {{year}}-{{month}} заблокирована: расчётный месяц можно менять только до конца следующего месяца ({{until}}). Изменить, выдать, отозвать или разблокировать его больше нельзя.',
        issuedRateMissingNotice: 'Для выданных строк ({{count}}) за период не найден тариф компании. Расчёт уже выдан и не изменится; проверьте запись о тарифе.',
        unpaidFiledNotice: 'Сотрудники ({{count}}) отметили дни, на которые не действует ни одна ставка, поэтому эти дни не оплачены: {{names}}. Перенесите дату начала ставки и пересчитайте.',
        issuedSkipped: 'Не вошли в расчёт и останутся без выплаты до исправления ({{count}}): {{names}}',
        selectAll: 'Выбрать всех незавершённых',
        selectPerson: 'Выбрать: {{name}}',
        finalizeSelected: 'Утвердить ({{count}})',
        finalizedSelected: 'Утверждено ({{count}}): {{names}}',
        withdrawSelected: 'Отозвать ({{count}})',
        withdrawSelectedTitle: 'Отозвать расчётные листы ({{count}})?',
        withdrawSelectedExplain:
          'Утверждённые листы не удаляются — каждый сохраняет свои суммы и помечается отозванным, для каждого сотрудника открывается черновик для исправления, и он возвращается в «Расчёт идёт». Премия, удержание и корректировка переносятся в черновик, и ничего не вычитается как уже выплаченное.',
        withdrawnSelected: 'Отозвано ({{count}}): {{names}}',
        withdrawSkipped: 'Не отозвано ({{count}}; откройте сотрудника, чтобы увидеть причину): {{names}}',
        calculatingAllIssued: 'Все в этом расчёте утверждены. Они в разделе «Выдано».',
        bankExport: 'Банковский файл',
        bankExportWithheld: 'Не вошли в файл и не получат выплату ({{count}}): {{names}}',
        bankNoAccount: 'Нет банковского счёта',
        bankNoPrimary: 'Основной счёт не выбран',
        payslipNotSent: 'Расчётный листок ещё не отправлен',
        payslipSent: 'Расчётный листок отправлен',
        payslipLanguage: 'Язык расчётного листка',
        payslipSentOn: 'Расчётный листок отправлен {{date}}',
        excelExportAdvance: 'Аванс в Excel',
        excelExportFinal: 'Расчёт в Excel',
        excelExportEmpty: 'Нет строк для таблицы.',
        excelExportNoAccount: 'Нет счёта ({{count}}), в таблице пусто: {{names}}',
        excelExportNoBank: 'Столбцы банка и счёта пусты: для номеров счетов нужно право salary.edit.',
        excelExportLeftOut: 'Строки с предупреждениями не вошли в таблицу ({{count}}): {{names}}',
        payslipsSent: 'Расчётных листков поставлено в очередь: {{count}}.',
        payslipsAlreadySent: 'Уже отправлено: {{count}} — повторно не уйдёт.',
        payslipsSuppressed:
          'Письма не отправлены: почта по нажатию кнопки выключена. Включите её в разделе «Настройки → Автоматизация».',
        payslipsSkipped: 'Не отправлено ({{count}}): {{names}}',
        noneComputed: 'Ни по кому нет расчёта. Проверьте «Внимание»; сотрудники без учтённого времени в списке не показываются.',
        nothingLoggedCount: 'Без учтённого времени: {{count}}',
        reason: 'Причина',
        issuesTitle: 'Требуют внимания',
        issuesHint: 'Пока не рассчитываются. Пока здесь кто-то есть, утвердить расчёт нельзя.',
        issuesNone: 'Проблем нет.',
        // The third list, and the opt-in that pays annual leave ahead.
        futureLeave: {
          title: 'Будущие отпуска',
          blockedFixed: 'Фиксированный оклад, поэтому заранее не выплачивается.',
          hint: 'Отпуска любого типа, которые продолжаются после отсечки этой выплаты, и какая выплата оплачивает ежегодный отпуск. Ежегодный отпуск, начинающийся до отсечки следующей выплаты, можно добавить в эту выплату.',
          none: 'Нет отпусков после отсечки этой выплаты.',
          person: 'Сотрудник',
          type: 'Тип',
          dates: 'С – по',
          days: 'Рабочих дней',
          pay: 'Зарплата',
          cancelPending: 'Ожидает отмены',
          paidBy: 'Оплачено в {{run}}',
          paidByUnknown: 'Оплачено проведённой выплатой',
          willBePaidBy: 'Будет оплачено в {{run}}',
          eligible: 'Можно добавить в эту выплату',
          added: 'Добавлено в эту выплату',
          add: 'Добавить в эту выплату',
          remove: 'Убрать из этой выплаты',
          addedToast: 'Добавлено в эту выплату.',
          removed: 'Убрано из этой выплаты.',
        },
        typicalShift: {
          loadFailed: 'Не удалось загрузить проекты.',
          saveFailed: 'Не удалось сохранить типичные часы для «{{project}}».',
          title: 'Типовая смена по проекту',
          subtitle: 'Максимум, который оплачивается в день простоя по проекту: отработанные часы плюс оплаченный простой не превышают это число. Действует для рабочих дней с 2026-09-24. По умолчанию 11.',
          product: 'Проект',
          hours: 'Типовые часы',
          save: 'Сохранить',
          saved: 'Типовая смена сохранена.',
          invalid: 'Введите число больше 0 и не больше 24 (до 2 знаков после запятой).',
          empty: 'Проектов нет.',
          inactive: 'неактивен',
        },
        taskRules: {
          loadFailed: 'Не удалось загрузить правила сдельных ставок.',
          newSetOpen: 'Форма нового набора правил уже открыта.',
          createFailed: 'Не удалось создать набор правил.',
          title: 'Правила ставок за задания',
          subtitle: 'Ступенчатая оплата за задание или единицу. Количество за день выбирает ОДНУ ступень, и все единицы дня оплачиваются по её ставке. Счёт обнуляется каждый день.',
          effectNotice: 'Изменение версии пересчитывает открытые (невыданные) расчёты с даты её начала. Выданные расчётные листки не меняются. Безопасный путь: добавить новую дату начала действия.',
          loading: 'Загрузка наборов правил…',
          empty: 'Правил ставок за задания пока нет.',
          newSet: 'Новый набор правил',
          archiveFailed: 'Не удалось изменить «{{name}}».',
          deleteFailed: 'Не удалось удалить версию «{{name}}» от {{date}}.',
          unchanged: 'Пока ничего не изменено.',
          setName: 'Название',
          unitLabel: 'Название единицы',
          unitLabelHint: 'Показывается в расчётном листке как введено, например «коробка». Не переводится.',
          createSet: 'Создать набор правил',
          assigned: 'Назначено: {{n}}',
          archivedBadge: 'В архиве',
          archive: 'В архив',
          unarchive: 'Восстановить',
          noVersions: 'Ступеней пока нет. Добавьте первую дату начала ниже.',
          colEffectiveSince: 'Действует с',
          colFrom: 'От',
          colTo: 'До',
          colRate: 'Ставка за единицу',
          openEnded: 'и выше',
          addDate: 'Добавить новую дату начала',
          addDateHint: 'Новая дата не затрагивает прошлые дни: они остаются со своими ступенями. Первая ступень начинается с 1; «до» вычисляется из следующего «от».',
          editVersion: 'Изменить эту дату',
          addTier: 'Добавить ступень',
          removeTier: 'Удалить ступень',
          saveNew: 'Добавить дату начала',
          saveReplace: 'Заменить эту версию',
          cancel: 'Отмена',
          versionExists: 'Версия на {{date}} уже есть — сохранение заменит её и пересчитает открытые расчёты.',
          confirmOverwrite: 'Заменить версию на {{date}}? Открытые расчёты с этой даты будут пересчитаны.',
          deleteVersion: 'Удалить эту дату',
          confirmDelete: 'Удалить версию на {{date}}? Открытые расчёты с этой даты будут пересчитаны.',
          saved: 'Набор правил сохранён.',
          effectiveRequired: 'Выберите дату начала действия.',
          nameRequired: 'Введите название.',
          previewTitle: 'Проверить день',
          previewCount: 'Единиц за день',
          previewResult: '{{n}} × {{rate}} = {{pay}} (ступень от {{min}})',
          previewNone: 'День без единиц ничего не приносит.',
          decreasingHint: 'Ступень {{row}} платит за единицу меньше предыдущей. Это допустимо; проверьте, что так задумано.',
          invalid_empty: 'Добавьте хотя бы одну ступень.',
          invalid_blank: 'Ступень {{row}}: заполните количество и ставку.',
          invalid_not_a_number: 'Ступень {{row}}: введите числа.',
          invalid_not_whole: 'Ступень {{row}}: количество должно быть целым.',
          invalid_negative_rate: 'Ступень {{row}}: ставка не может быть отрицательной.',
          invalid_too_precise: 'Ступень {{row}}: у ставки не больше 2 знаков после запятой.',
          invalid_first_not_one: 'Первая ступень должна начинаться с 1.',
          invalid_not_increasing: 'Ступень {{row}}: количество должно быть больше, чем у ступени выше.',
          segPay: 'Оплата заданий',
          segUnitDefault: 'заданий',
        },
        warn: {
          rate_missing: 'Ставка не задана',
          payroll_rate_missing: 'За этот период не найден тариф компании по оплате труда',
          shift_source_missing: 'Нет данных о сменах (график ещё не связан с сервером)',
          social_band_missing: 'Категория соцстрахования не найдена',
          leave_factor_missing: 'Нет истории за 12 месяцев — средний дневной заработок не рассчитан',
          pay_basis_unrecognised: 'Вид ставки оплаты не распознан',
          task_rule_version_missing: 'У набора правил заданий нет действующей версии на отработанный день — день оценён в 0',
          unpaid_filed_days: 'Отмеченные дни ({{count}}) не оплачены — на них не действует ни одна ставка: {{days}}',
          cl_year_end_unpriced: 'Ставка не задана — годовая выплата за неиспользованный отпуск не рассчитана',
          psl_year_end_reset_missing: 'Сброс отпусков на 31 декабря прошлого года не выполнен — выплата за неиспользованный PSL в этот расчёт не вошла',
          contractor_entry_unpriced: 'Утверждённая запись журнала подрядчика приходится на дату без ставки «день + час» — она не оплачена',
          final_issued: 'Окончательный расчёт за этот месяц выдан раньше аванса, поэтому аванс не выдаётся',
          break_payout_balance_short: 'Остаток AL, CL или PSL меньше того, что было учтено при начислении выплаты за перерыв, поэтому расчёт не выдаётся: аннулируйте выплату за перерыв и рассчитайте вручную',
          break_payout_leave_row_changed: 'После начисления выплаты за перерыв остатки отпусков начислены заново, поэтому расчёт не выдаётся: аннулируйте выплату за перерыв и рассчитайте вручную',
        },
        period: 'Расчётный период', people: 'Сотрудники', totalGross: 'Итого начислено', gross: 'Начислено',
        company: 'Компания', model: 'Модель', modelDaily: 'Подневная', modelFixed: 'Оклад', modelHourly: 'Почасовая',
        rate: 'Ставка', worked: 'Отработано (ч/смен)',
        run: 'Расчёт', run_advance: 'Аванс', run_final: 'Окончательный',
        mode: 'Режим', mode_calculating: 'Расчёт идёт', mode_issued: 'Утверждён',
        selectAllIssued: 'Выбрать всех выданных',
        noneIssued: 'В этом расчёте пока никто не выдан.',
        sendPayslip: 'Отправить расчётный листок ({{count}})',
        sendPayslipTitle: 'Отправить расчётный листок {{count}} сотрудникам?',
        sendPayslipExplain: 'Кто уже получил этот листок, повторно его не получит; листок, отозванный, исправленный и выпущенный заново, отправляется снова. Отправленное письмо отозвать нельзя.',
        covers: 'Период {{start}} → {{end}}',
        heading: {
          progress: '{{month}}, {{run}} — выдано: {{issued}}, осталось: {{left}}',
          notIssued: '{{month}}, {{run}} — ещё не выдано, отсечка {{cutOff}}',
          notIssuedNoCut: '{{month}}, {{run}} — ещё не выдано',
        },
        social: 'Соцстрахование', tax: 'НДФЛ', net: 'К выплате',
        advance: 'Аванс', remainder: 'Остаток к выплате',
        totalAdvance: 'Итого аванс', totalRemainder: 'Итого остаток', totalNotKnown: 'Неизвестно',
        advancePaid: 'Ранее выплаченный аванс',
        // Единственная причина, по которой остаток в окончательном расчёте
        // равен ровно 0: аванс уже полностью покрыл чистую зарплату. Просто
        // «0» выглядит так, будто человеку ничего не выплатили.
        settledByAdvance: 'Полностью выплачено авансом (начислено {{gross}})',
        advanceAdjustment: 'Корректировка, перенесённая из аванса',
        netAdjustment: 'Корректировка после налога',
        clYearEndPay: 'Выплата за неиспользованный PSL',
        payNote: {
          pslPriced: 'PSL {{days}} дн. x 8 ч x {{rate}} = {{amount}}',
          pslLapseFixed: 'PSL {{days}} дн. ({{year}}) сгорают без оплаты: оклад',
          breakNetZero: 'Начислено CL {{award}} дн. минус {{back}} дн. возврата: итого 0 дн.',
          breakUnpaidFixed: 'CL/PSL {{days}} дн. рассчитаны без оплаты: оклад',
          breakUnpaid: 'CL/PSL {{days}} дн. рассчитаны без оплаты',
        },
        activityBonus: 'Бонус из фонда активности',
        loadFailed: 'Не удалось загрузить этот расчёт.',
        activityWorking: 'Оплачено месяцев: {{months}} · {{points}} балл. × {{rate}} = {{total}}',
        activityNoMonths: 'В том году взносов в фонд не было',
        activityFund: {
          mark: 'Выплатить в этом расчёте',
          unmark: 'Снять отметку',
          unmarked: 'Этот окончательный расчёт не выплачивает фонд активности за {{fundYear}} год',
          marked: 'Этот окончательный расчёт выплачивает фонд активности за {{fundYear}} год: баллы × ежемесячный взнос',
          elsewhere: 'Фонд активности за {{fundYear}} год выплачивается в окончательном расчёте {{year}}-{{month}}',
          off: 'Бонус из фонда активности отключён для этой организации, пока не решён вопрос налогообложения',
          hint: 'Раз в год отмечается один окончательный расчёт. Он выплачивает каждому баллы за месяцы взносов в фонд в {{fundYear}} году, умноженные на ежемесячный взнос. Сумму не вводят вручную: исправления вносятся в таблицу фонда, и расчёт пересчитывается.',
          markConfirm: 'Выплатить фонд активности за {{fundYear}} год в этом окончательном расчёте?',
          unmarkConfirm: 'Убрать фонд активности за {{fundYear}} год из этого окончательного расчёта?',
          markDone: 'Этот расчёт теперь выплачивает фонд активности за {{fundYear}} год',
          unmarkDone: 'Этот расчёт больше не выплачивает фонд активности за {{fundYear}} год',
          blocked: {
            future: 'Расчёт будущего года отметить нельзя',
            issued: 'В этом расчёте есть выпущенные расчётные листы; сначала аннулируйте их',
            locked: 'Этот месяц закрыт или заблокирован',
          },
        },
        breakAlPay: 'Начало отпуска или уход с полной занятости: заработанный AL (после налога)',
        breakClPslPay: 'В том числе расчёт CL/PSL при начале отпуска или уходе с полной занятости (облагается как зарплата)',
        leavePayoutOfWhich: 'В том числе выплата за неиспользованный отпуск при увольнении',
        alSettlementOfWhich: 'В том числе ежегодный отпуск, выплаченный по вашей заявке',
        // Личный портал расчётных листков
        paidOut: 'Выплачено',
        viewPayslip: 'Открыть',
        shiftsN: 'смен: {{count}}', hoursN: '{{count}} ч',
        shiftsUnit: 'смен', tasksUnit: 'задач', hoursUnit: 'ч',
        socialTag: 'Категория соцстрахования {{tag}}',
        socialAt: 'Соцстрахование {{percent}}%', taxAt: 'НДФЛ {{percent}}%',
        socialCapped: 'Предел: свыше {{cap}} взносы не начисляются.',
        segmentTotal: 'Периоды ставки', segmentGross: 'Начислено за период', allowances: 'Надбавки',
        p73: {
          help: "Пояснение",
          reportedHours: 'Учтённые часы',
          weightedHours: 'Взвешенные часы',
          reportedShifts: "Введено смен",
          weightedShifts: "Оплачено смен",
          hoursTitle: "Часы: введено (с коэффициентами)",
          paidLeave: "Оплачиваемый отпуск (PSL / CL / SPL)",
          annualLeave: "Ежегодный отпуск (AL)",
          annualLeaveDays: "{{days}} дн. · {{hours}} ч",
          shiftsTitle: "Смены: введено (оплачено)",
          taskTotal: "{{count}} задач = {{amount}}",
          taskDatesUnavailable: "Для этого расчёта задачи по датам не сохранены, показать их нельзя. Итог — данные самой ведомости.",
          t60: "В пути, учитывается на 60%",
          totals: "Итого",
          normalHint: "H, DT и PD оплачиваются одной суммой: H {{h}} · DT {{dt}} · PD {{pd}}",
          gap: "Дни выше расходятся с итогом ведомости на {{sign}}{{gap}} ч — так бывает при перенесённом дне.",
          hoursHelp: "В каждой ячейке: введено часов (с коэффициентами). Коэффициенты: сверхурочные 1,5, ночные 1,2, ночь + СУ 1,8, в пути 0,6. PD ограничено 10% работы дня; простой учитывается на 60%, а с 2026-09-24 ограничен типовой длиной смены проекта. H, DT и PD округляются одной суммой. Строка итога — цифра самой ведомости; оплачиваемый отпуск и праздник считаются по 8 ч в день. В день на окладе оплата не зависит от часов.",
          shiftsHelp: "Каждая дата: введено смен (оплачено смен). Смена в пути (T) оплачивается на 60%. Итог — число смен самой ведомости. Оплаченные смены разбиты по видам: D день, N ночь, L лесозаготовка, T в пути (×0.6), DT простой (×0.6).",
          formulaHelp: "Каждая строка: количество × коэффициент × ставка. Коэффициент показан, только если он точно делит ставку. Строки должны в сумме дать начисление. Сегмент Daily со второй (дополнительной) ставкой показан одной строкой без количество × ставка: сохранённая разбивка не хранит, какие смены оплачены по какой ставке.",
          figuresHelp: 'Соцстрахование = min(начислено, лимит) × его процент; лимит и процент берутся из кода соцстрахования ставки, действующей на дату итогового расчёта периода (final cut). Подоходный налог = (начислено − соцстрахование) × процент налога. Освобождение обнуляет этот процент на месяц.',
          socialBaseCapped: "База: min(начислено {{gross}}, лимит {{cap}}) = {{base}}",
          socialBaseGross: "База: начислено {{base}} (лимит не задан)",
          baseNotRecorded: "База: не записана в утверждённом расчёте",
          taxBase: 'База налога (начислено − соцстрахование)',
          figuresTitle: "Итоговые суммы",
          exemptSocial: 'Освобождён от соцстрахования (0%)',
          exemptTax: 'Освобождён от НДФЛ (0%)',
          ratePeriods: "Периоды ставок ({{count}})",
        },
        dayHours: {
          day: 'День', ordinary: 'Обычные', downtime: 'Простой', pd: 'PD',
          total: 'Итого за день',
          carried: 'прошлый месяц', fixed: 'оклад',
          notRecorded: 'Эта ведомость утверждена до того, как часы по дням стали сохраняться.',
          
        },
        frozenAtIssue: 'Расчёт в том виде, в каком он был зафиксирован при утверждении. Последующие правки табеля его не меняют.',
        carryOver: 'День прошлого месяца, утверждённый уже после закрытия того расчёта. Оплачен сейчас по ставке, действовавшей в тот день.',
        noFrozenBreakdown: 'Эта утверждённая строка сохранена без расшифровки, поэтому суммы ниже ничем не объясняются.',
        ledgerSegment: 'Ведомость аванса',
        ledgerSegmentWhy: 'У аванса нет ни своего типа оплаты, ни ставки — это запись о том, за какие дни он выплачен. Ставка — в основном расчёте.',
        monthFigureHint: 'Начислено, социальное страхование и НДФЛ — за весь месяц; Аванс и Остаток — чистая выплата каждой части.',
        correctionsTitle: 'История исправлений',
        correctionsNone: 'В этом месяце отозванных расчётных листов нет.',
        withdraw: 'Отозвать и открыть заново',
        withdrawConfirm: 'Отозвать',
        withdrawReason: 'Причина отзыва',
        withdrawExplain:
          'Утверждённый лист не удаляется — он сохраняет свои суммы, помечается как отозванный, и рядом открывается черновик для исправления. Премия, удержание и корректировка нетто переносятся в черновик, и ничего не вычитается как уже выплаченное.',
        withdrawn: 'Расчётный лист отозван, открыт черновик для исправления.',
        withdrawnLabel: 'Отозван',
        withdrawnBecause: 'Причина: {{reason}}',
        p83: {
          workedHint: "Отработанные часы (или смены) + отпуск, оплачиваемый в этом расчёте. * = ежегодный отпуск, оплаченный заранее",
          partHours: "Отработано часов: {{value}}",
          partShifts: "Отработано смен: {{value}}",
          partTasks: "Выполнено задач: {{value}}",
          partLeave: "{{code}}: {{value}} ч оплачиваемого отпуска, входят в часы",
          partAl: "Ежегодный отпуск: в этом расчёте оплачивается {{value}} дн.",
          aheadHint: "* оплачено заранее — отпуск начинается после этого периода",
          annualLeaveAhead: "Ежегодный отпуск, оплачен заранее",
        },
        p70: {
          carryNoRun: "Итоговый расчёт прошлого месяца этому сотруднику не начислялся, поэтому день оплачивается в этом расчёте.",
          formulaSince: "(с {{date}})",
          carriedLeave: "Поздно утверждённый отпуск: {{leave}} дн.",
          segmentHolidays: "Праздники: {{dates}}",
          colModeDays: "Дни (F/T)",
          modeDaysHint: "Дни за период: F полевые, T транзит, BTA командировка за рубеж, BTL командировка внутренняя",
          modeChipHint: "{{code}}: {{days}} дн.",
          transitNotOnRate: "T: не в ставке",
          transitNotOnRateHint: "Есть дни транзита, но ставка этого сотрудника не включает транзитную надбавку.",
          formulaTitle: "Из чего складывается начисление",
          formulaMismatch: "Слагаемые не дают сумму начисления — сообщите в расчётный отдел.",
          colLeave: "Отпуск (CL/PSL/SPL/AL)",
          leaveWaiting: "Отпуска: ждём сервер",
          leaveTotalsLead: "В этом периоде:",
          leaveTotalsItem: "{{code}} {{days}} дн. ({{people}} чел.)",
          chipHint: "{{code}} {{days}} дн. — открыть отпуска",
          chipUnpaidHint: "{{code}} {{days}} дн., часть не оплачена — открыть отпуска",
          taskValue: 'Оплата заданий',
          info: {
            badgeHint: "{{count}} чел. с отпуском или перенесёнными часами",
            button: "О периоде",
            title: "Этот расчётный период",
            holidays: "Праздники в этом периоде",
            noHolidays: "В этом периоде праздников нет.",
            notReported: "Не передаётся",
            carried: "Деньги прошлых периодов в этом расчёте",
            noCarried: "Денег из прошлых периодов нет.",
            carriedLeaveNotReported: "Поздно утверждённые отпуска (P67) пока не выделяются — они могут быть среди дат выше.",
            other: "Прочее, что меняет оплату",
            draft: "Черновик",
            issued: 'Утверждён',
            issues: 'Невозможно рассчитать',
            leaversNotReported: "Уволившиеся, принятые и волонтёры сервером пока не передаются.",
            fact: {
              unlocked: "Выплаченный аванс разблокирован",
              taxExempt: "Освобождён от НДФЛ",
              socialExempt: 'Освобождён от соцстрахования',
              grossOverride: "Начисление изменено вручную",
              figuresUnrecorded: "Суммы не записаны (импорт)",
            },
            prevTime: "Перенесённые часы",
            prevUnpaidFiled: "Дни без ставки, не оплачены: {{dates}}",
            prevNoRun: "Итоговый расчёт за {{period}} не начислялся — этот период оплачивается здесь: {{days}} дн.",
            prevNoRunAl: "AL {{days}} дн.",
            prevNoRunHours: "{{hours}} ч",
          },
          leavesTitle: "Отпуска в этом расчёте",
          leavesCaveat: "Показаны только люди из этого расчёта — уволившиеся или волонтёры, которых нет в списке, не отображаются.",
          leavesNone: "В этом расчёте ни у кого нет отпусков.",
          leavesUnknown: "Сервер пока не передаёт данные об отпусках.",
          colName: "Имя",
          colType: "Тип отпуска",
          colDates: "Даты",
          colDays: "Дни",
          colPaid: "Как оплачено",
          leaveCountHint: "Дни отпуска за период: CL / PSL / SPL / AL",
          groupFullTime: 'Штатные',
          groupRest: "Остальные",
          workedPlusLeave: "Работа + отпуск: {{dates}}",
          personLeavesTitle: "Отпуска за период",
          personLeavesNone: "За этот период отпусков нет.",
          personLeavesUnlisted: "Только отпуск, который здесь не учитывается, например RL или UL.",
          uncountedLeave: "Отпуск, 0 дн.",
          uncountedLeaveHint: "В этом периоде есть утверждённый отпуск, но в этом расчёте не учтён ни один его день — открыть отпуска",
          halfDay: "полдня",
          part: {
            normal: "Обычные",
            overtime: "Сверхурочные",
            night: "Ночные",
            over_night: "Ночь + СУ",
            transit: "В пути",
            leave: "Оплачиваемый отпуск",
            holiday: "Праздничные",
          },
          treatment: {
            paid: "Оплачен",
            partly_paid: "Частично оплачен ({{paid}} из {{days}} дн.)",
            over_annual_cap: "Сверх годового лимита — не оплачен",
            annual_leave: "Ежегодный отпуск (через отпускные)",
            covered_by_fixed_salary: "Покрыт окладом",
            not_paid: "Не оплачивается",
            not_recorded: "Не зафиксировано",
            al_other_run: "Оплачивается в другом расчёте",
          },
        },
        p62: {
          decisionsTitle: 'Решения',
          unlock: 'Разблокировать',
          unlockConfirm: 'Разблокировать',
          unlockReason: 'Почему разблокируется',
          unlockExplain: 'Выплаченный аванс заблокирован от отзыва. Разблокировка — осознанное действие и записывается с причиной.',
          unlocked: 'Аванс разблокирован.',
          lockedNote: 'Этот аванс выплачен, поэтому заблокирован. Чтобы отозвать его, сначала разблокируйте с указанием причины.',
          unlockedNote: 'Разблокирован. Причина: {{reason}}',
          advanceLocked: 'Этот аванс выплачен и заблокирован. Сначала разблокируйте его с указанием причины.',
          finalIssued: 'Окончательный расчёт за {{month}} уже выдан и удержал этот аванс. Сначала аннулируйте окончательный расчёт.',
          oneOffIssued: 'Разовый расчётный лист за {{month}} уже выдан и использовал часть месячного лимита соцстрахования. Сначала аннулируйте и перевыпустите разовый лист, а после повторной выдачи этого расчёта выдайте его снова.',
          laterIssued: 'Расчёт «{{run}}» за {{month}} выдан после этого. Аннулировать можно только последний расчёт, поэтому сначала аннулируйте его.',
          awaitingReissueAsk: 'Аванс сотрудников {{names}} аннулирован и ещё не выдан повторно, поэтому их окончательный расчёт выдать нельзя. Выдать окончательный расчёт остальным сейчас?',
          oneOffFirst: 'Разовый расчётный лист за {{month}} уже выдан и использовал часть месячного лимита соцстрахования. Сначала аннулируйте и перевыпустите разовый лист, а после этого окончательного расчёта выдайте его снова.',
          oneOffFirstAsk: 'У сотрудников {{names}} в этом месяце уже выдан разовый расчётный лист, поэтому их окончательный расчёт нельзя выдать, пока он не аннулирован и не перевыпущен. Выдать окончательный расчёт остальным сейчас?',
          issueOthers: 'Утвердить остальные',
          advanceAwaitingReissue: 'Аванс за {{month}} аннулирован и ещё не выдан повторно. Выдайте его повторно до окончательного расчёта.',
          monthClosed: 'Расчёт зарплаты за {{month}} закрыт. Чтобы это изменить, администратор должен сначала переоткрыть месяц.',
          monthNoFinalPeriod: 'В календаре нет окончательного периода выплаты за {{month}}. Добавьте его перед закрытием месяца.',
          exemptTitle: 'Освобождение от налога и соцстрахования',
          exemptHint: 'Действует для каждого месяца, период которого начинается в эту дату или позже. Выпущенные расчётные листы не меняются. Чтобы завершить освобождение, добавьте строку с обоими выключенными флажками.',
          exemptTax: 'Освободить от НДФЛ',
          exemptSocial: 'Освободить от соцстрахования',
          exemptNeither: 'без освобождения',
          exemptSince: 'Действует с',
          exemptReason: 'Причина',
          exemptAdd: 'Добавить освобождение',
          exemptSave: 'Сохранить',
          exemptSaved: 'Освобождение сохранено.',
          exemptDelete: 'Удалить',
          exemptRow: 'С {{since}}: {{what}} — {{reason}}',
          exemptInForce: 'Действует в этом месяце: {{what}}',
          calendarUnconfirmed: 'Зарплату за этот месяц нельзя начать, пока календарь на {{years}} год не подтверждён. Сначала подтвердите год.',
          openCalendar: 'Открыть календарь',
          onePerMonth: '{{field}}: уже указано в расчёте «{{run}}» этого месяца. Допускается только раз в месяц — сначала очистите там.',
          field_bonus: 'Премия',
          field_deduction: 'Удержание до налогов',
          field_net_adjustment: 'Удержание после налогов',
        },
        leaveTopUp: 'Отпускные: {{days}} дн. × {{factor}}',
        leaveInFixed: 'Не добавлено: месяц заканчивается на окладе, эти дни уже учтены.',
        bonus: 'Премия', deduction: 'Удержание', note: 'Примечание',
        shifts: 'Смены', includedDays: 'Учтённых дней', alDays: 'Дни ежегодного отпуска (AL)',
        models: 'Модель оплаты',
        overrideValue: 'Ручное значение начисления',
        byHand: 'Рассчитано вручную',
        grossSetByPayroll: 'Начислено (установлено расчётным отделом)', notApplied: '{{amount}} — не учтено',
        allowancesNotApplied: 'Не учтено: начисление по этому листку установлено расчётным отделом.',
        proration: 'Рабочих дней в периоде / месяце', reportedHours: 'Учтённые часы',
        weightedHours: 'Взвешенные часы',
        perDaily: 'за смену', perHourly: 'за час', perFixed: 'в месяц',
        branchAdditionalShort: 'Вторая ставка {{rate}}: документирование и простой полностью, дорога 0.6.',
        branchRateShort: 'Базовая ставка: документирование полностью, простой и дорога 0.6.',
        periods: 'Расчётные периоды',
        periodsHint: 'Календарь выплат, от которого считается расчёт, и та же граница, дальше которой не может уйти самостоятельное редактирование и админская коррекция в разделе «Время и отпуска». До сих пор эта таблица пополнялась только импортом.',
        periodsRunningLow: 'Календарь выплат заканчивается {{date}}. После этой даты изменять и утверждать фактическое время сможет только администратор времени. До этого подтвердите следующий год в календаре праздников и создайте его периоды.',
        periodsEnded: 'Календарь выплат закончился {{date}}, поэтому изменять и утверждать фактическое время может только администратор времени. Подтвердите следующий год в календаре праздников и создайте его периоды.',
        periodsGenerate: 'Создать следующие периоды',
        periodsGenerateHint: 'Рассчитывается по правилу даты выплаты: выплата приходится на последний рабочий день не позже 11-го и 26-го числа, а дата отсечения — на два дня раньше. Государственные праздники и выходные сдвигают дату выплаты; дата отсечения следует за ней и сама может выпасть на выходной. Эти даты нельзя изменить вручную — чтобы сдвинуть дату, исправьте праздники этого года в календаре праздников.',
        periodsYearNotConfirmed: 'Календарь праздников не подтверждён на {{years}}, поэтому даты для этих месяцев рассчитаны только по выходным и пропустят все государственные праздники. Подтвердите {{years}} в календаре праздников или выберите меньше месяцев.',
        periodsPropose: 'Предложить',
        periodsHowMany: 'На сколько вперёд',
        periodsMonthsN: 'месяцев: {{count}}',
        periodsProposedNote: '{{note}}',
        periodsNothingToAdd: 'Нет новых месяцев для добавления.',
        tickFirst: 'Сначала отметьте хотя бы одного сотрудника.',
        busyWhy: 'Выполняется…',
        firstPage: 'Это уже первая страница',
        lastPage: 'Это уже последняя страница',
        nothingToExport: 'Нет строк для экспорта',
        noPeriodLoaded: 'Период ещё не загружен',
        rowLocked: 'Строка выдана, или у вас нет прав на изменение',
        tickOtherMode: 'Этот сотрудник относится к другому виду',
        closeUnknown: 'Конец периода пока не известен',
        reasonFirst: 'Сначала укажите причину.',
        dateAndReasonFirst: 'Сначала укажите дату и причину.',
        periodsLoadFailed: 'Не удалось загрузить календарь выплат.',
        periodsProposeFailed: 'Не удалось загрузить предлагаемые месяцы.',
        periodsSaveFailed: 'В календарь выплат ничего не добавлено.',
        periodsGenerateSave: 'Сохранить периоды ({{count}})',
        periodsGenerated: 'Добавлено периодов в календарь выплат: {{count}}.',
        periodsEmpty: 'Расчётного календаря пока нет. Он создаётся при подтверждении текущего года в разделе Администрирование, Конфигурация, Календарь праздников.',
        periodsReadOnly: 'Календарь доступен для просмотра, но не для изменения.',
        periodsMonth: 'Месяц',
        periodsPayDate: 'Дата выплаты',
        periodsCutOff: 'Отсечка',
        daysPaid: 'Оплаченные дни', shiftDaysPaid: 'Оплаченные смены',
        holidaysCredited: 'Зачтённые праздничные дни (по 8 ч)',
        excludedDays: 'Неоплаченные дни',
        excludedNone: 'Все дни этого периода оплачены.',
        excluded_holiday: 'Праздничный день',
        excluded_weekend: 'Выходной',
        excluded_leave: 'В отпуске',
        excluded_work_mode: 'Табель утверждён, но не вошёл в расчёт',
        excluded_not_approved: 'Табель не утверждён',
        excluded_unaccounted: 'Ничто не объясняет этот день',
        excluded_al_unrecorded: 'Отпуск — в этой расчётке не записано, какие дни оплачены',
        alPaidDates: 'Оплаченные дни',
        workModeDays: 'Дни по режиму работы', leaveBreakdown: 'Разбивка отпуска',
        notRecorded: 'Не определено — утверждено до появления этого учёта',
        none: 'Нет',
        hoursSummary: 'Часы по периодам',
        hoursByType: 'Часы по типам',
        hourType_normal: 'Обычные', hourType_overtime: 'Сверхурочные',
        hourType_night: 'Ночные', hourType_over_night: 'Сверхурочные ночью',
        hourType_transit: 'В пути',
        hoursWeighted:
          'Итог выше — взвешенный: каждый тип часов считается по своему коэффициенту, а оплачиваемый отпуск и праздничные дни засчитываются по 8 часов в день. Здесь показаны часы так, как вы их отметили, поэтому их сумма не совпадает с итогом.',
        paidTotal: 'Выплачено всего', runNotIssued: 'Не утверждено',
        viewRunPayslip: '{{period}} {{run}} — открыть расчётный лист',

        settlementsTitle: 'Расчёты по отпуску',
        settlementsHint:
          'Заявки на выплату накопленного ежегодного отпуска при увольнении, отпуске по беременности и родам или по личному заявлению. Утвердите или отклоните этап, который подписываете вы.',
        settlementPerson: 'Сотрудник', settlementTrigger: 'Тип',
        settlementDays: 'Дни', settlementDaysUnit: 'дн.',
        settlementStatus: 'Статус', settlementCreated: 'Подана',
        settlementRelevantDate: 'Соответствующая дата', settlementReason: 'Причина',
        settlementComment: 'Комментарий', settlementRejectionHint: 'Обязательно при отклонении',
        settlementCommentRequired: 'При отклонении нужен комментарий',
        settlementReject: 'Отклонить', settlementApprove: 'Утвердить',
        settlementDecided: 'Решение зафиксировано', settlementClose: 'Закрыть',
        settlementTriggerResignation: 'Увольнение',
        settlementTriggerMaternity: 'Отпуск по беременности и родам',
        settlementTriggerOther: 'По заявлению',
        settlementStageManagement: 'Руководство', settlementStageFinance: 'Финансы',
        settlementStatusApproved: 'Утверждено', settlementStatusRejected: 'Отклонено',
        settlementStatusPending: 'На утверждении',
        settlementFullWorking: 'Ваш остаток {{balance}} дн. минус {{unearned}} дн. из годовой нормы {{allocation}} дн., ещё не заработанные: {{worked}} из {{yearDays}} рабочих дней по {{countedTo}} дают {{earned}} дн. (праздники не считаются).',
        settlementFullNoLeavingDate: 'Отдел кадров ещё не зарегистрировал дату вашего увольнения.',
        settlementFullNoBreakStart: 'Укажите дату начала отпуска по беременности и родам.',
        settlementFullNoBreakOnRecord: 'Утверждённый отпуск по беременности и родам или по уходу за ребёнком с этой даты не найден; укажите дату начала утверждённого отпуска.',
        settlementFullNoLeaveInfo: 'У вас нет зарегистрированного права на ежегодный отпуск.',
        settlementFullAllocationUnknown: 'Ваша годовая норма отпуска не зарегистрирована, поэтому расчёт невозможен; обратитесь в отдел кадров.',
        settlementFullNothingToSettle: 'Заработанного отпуска к расчёту нет.',
        settlementRequestHint:
          'Подайте заявку на выплату выбранных дней накопленного ежегодного отпуска. При увольнении отдел кадров выплачивает отпуск при закрытии расчёта; отпуск по беременности и родам бухгалтерия выплачивает автоматически при его начале.',
        settlementSubmit: 'Отправить заявку', settlementMyRequests: 'Мои заявки',
        settlementRequested: 'Заявка на расчёт отправлена',
        settlementStageSupervisor: 'Руководитель',
        settlementPreviewBalance: 'Ежегодный отпуск: {{before}} → {{after}} дн.',
        settlementPreviewBalanceNow: 'Ежегодный отпуск: {{balance}} дн.',
        settlementPreviewPending: 'Ещё {{days}} дн. из ваших заявок ждут решения.',
        settlementPreviewAmount: 'Ориентировочная сумма: {{amount}} ({{days}} дн. × {{dayValue}}), до налогов. Окончательная сумма рассчитывается в день утверждения.',
        settlementPreviewPayDay: 'Ориентировочная дата выплаты: {{date}}, с окончательной зарплатой после утверждения.',
        settlementPreviewOverMax: 'Можно запросить не более {{max}} дн.',
        settlementPreviewOverMaxReserve: 'Можно запросить не более {{max}} дн.: {{reserve}} дн. остаются в резерве на основной отпуск этого года.',
        settlementRefusedContractor: 'У подрядчиков нет ежегодного отпуска для выплаты.',
        settlementRefusedClosedOut: 'Ваш отпуск уже закрыт расчётом.',
        settlementPaid: 'Выплачено',
        settlementAwaitingPay: 'С ближайшей окончательной зарплатой',
        settlementsToDecide: 'Выплаты на решение',
        payoutTag: 'Выплата',
        payoutsAwaitingBadge: 'Выплаты за отпуск, ожидающие вашего решения: {{count}}',
        settlementAmount: 'Сумма',
        settlementYouSign: 'Ваше решение подписывает этапы: {{stages}}',
      },
  },
}
